import { Component, HostBinding, OnInit, ViewChild } from "@angular/core";
import { NGXLogger } from "ngx-logger";
import {
  ConfirmationService,
  MenuItem,
  Message,
  MessageService,
  PrimeIcons,
} from "primeng/api";
import { environment } from "../../../../../environments/environment";
import { Menu } from "primeng/menu";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";

import { ActivatedRoute, Router } from "@angular/router";
import { Impresa } from "src/app/models/impresa.model";
import { ImpreseService } from "src/app/services/imprese.service";
import {
  AngularFirestore,
} from "@angular/fire/compat/firestore";
import {
  onSnapshot,
  GeoPoint,
} from "firebase/firestore";
import { getStorage, ref, getBlob } from "firebase/storage";
import { saveAs } from "file-saver";

import { Observable, Subject } from "rxjs";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ExcelService } from "src/app/services/excelService.service";
import { Utente } from "src/app/models/utente.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { Location } from "@angular/common";
import * as Leaflet from "leaflet";
import { StoricoPraticheService } from "src/app/services/storicoPratiche.service";
import { NotaReworkPratica } from "src/app/models/pratica.nota.scuola.model";
import { NotePraticheService } from "src/app/services/notePratiche.service";
import { NotaPraticaDTO } from "src/app/models/pratica.notaDTO.scuola.model";
import { CsvboxLoaderService } from "src/app/services/csvbox-loader.service";
import * as JSZip from "jszip";
import { ModificaPraticaDTO } from "src/app/models/modificaPratica.scuola.model";
import { AutoCompleteCompleteEvent } from "primeng/autocomplete";
import { Tipologia } from "src/app/models/tipologia.model";
import { ComuniService } from "src/app/services/comuni.service";
import { ComuneDTO } from "src/app/models/comune.model";
import { NgxFileDropEntry } from "ngx-file-drop";
import { PraticaSanita_Firestore } from "src/app/models/praticaSanitaFirestore.model";
import { PraticheSanitaService } from "src/app/services/pratiche.sanita.service";
import { PraticaSanita } from "src/app/models/pratica.sanita.model";
import { PraticaScuola } from "src/app/models/pratica.scuola.model";
import { PianoTecnicoSanitaService } from "src/app/services/piano-tecnico-sanita.service";
import { PianoTecnicoSanita_Firestore } from "src/app/models/pianoTecnicoSanitaFirestore.model";
import { PianoTecnicoSanita } from "src/app/models/pianoTecnicoSanita.model";


Leaflet.Icon.Default.imagePath = "assets/leaflet/images/";

declare const CSVBoxImporter: any;
@Component({
  selector: "app-piani-tecnici-sanita",
  templateUrl: "./piani-tecnici-sanita.component.html",
  styleUrls: ["./piani-tecnici-sanita.component.scss"],
  providers: [DialogService, ConfirmationService],
})
export class PianiTecniciSanitaComponent implements OnInit {
  isLoadingResults = false;
  resultsLength = 0;
  pianiTecniciSanitaAtFirestore: PianoTecnicoSanita_Firestore[] = [];
  selectedPianoTecnico: PianoTecnicoSanita_Firestore;


  public isAdmin: boolean = false;
  public isSuperAdmin: boolean = false;
  public isPresidioSF: boolean = false;
  public isPresidioTIM: boolean = false;
  public isDirigenteFirmaVerbali: boolean = false;
  public isDirigenteFirmaPacchetti: boolean = false;
  protected hasPraticheDaFirmare:Boolean = false;

  public isImpresa: boolean = false;

  public imprese: MenuItem[] = [];

  //CSV BOX
  private csvbox_licenseKey_importaPraticheSanita:string=environment.csvBox.secret_importaPianiTecniciSanita;
  private csvbox_importer:any;

  private collection_piani_tecnici_sanita:string = environment.firebase.collection_piani_tecnici_sanita;

  public statiPratica: MenuItem[] = [];
  public statoFiltroSelezionato: MenuItem;


  @ViewChild("menuAzioni", { static: true }) azioniMenu: Menu;
  @ViewChild("menuAzioniTiered", { static: true }) azioniMenuTiered: Menu;
  protected menuAzioniItems!: MenuItem[];
  protected menuTieredAzioniItems!: MenuItem[];


  @ViewChild("menuStati") menuStati!: Menu;
  @ViewChild("menuTipiSede") menuTipiSede!: Menu;
  @ViewChild("menuRegioni") menuRegioni!: Menu;

  @ViewChild("pianiTecniciSanitaDT", { static: true }) pianiTecniciSanitaDT: any;

  @HostBinding("class.mobile") isMobile: boolean;

  protected msgs: Message[] = [];
  protected ref: DynamicDialogRef;
  protected dialogConfig:any;

  protected filterIsSet:Boolean = false;
  protected filtroStato:String;
  protected filtroPratica:String;

  public regioniPianiTecnici: MenuItem[] = [
    {
      label: "ABRUZZO",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("ABRUZZO", "regione", "is");
      },
    },
    {
      label: "CALABRIA",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("CALABRIA", "regione", "is");
      },
    },
    {
      label: "CAMPANIA",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("CAMPANIA", "regione", "is");
      },
    },
    {
      label: "LAZIO",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("LAZIO", "regione", "is");
      },
    },
    {
      label: "LIGURIA",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("LIGURIA", "regione", "is");
      },
    },
    {
      label: "LOMBARDIA",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("LAZIO", "regione", "is");
      },
    },
    {
      label: "MARCHE",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("MARCHE", "regione", "is");
      },
    },
    {
      label: "MOLISE",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("MOLISE", "regione", "is");
      },
    },
    {
      label: "PIEMONTE",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("PIEMONTE", "regione", "is");
      },
    },
    {
      label: "PUGLIA",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("PIEMONTE", "regione", "is");
      },
    },
    {
      label: "TOSCANA",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("TOSCANA", "regione", "is");
      },
    },
    {
      label: "TUTTE",
      command: (event) => {
        this.pianiTecniciSanitaDT.clear();
      },
    }
  ];

  public tipiSede: MenuItem[] = [
   
    {
      label: "A",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("A", "tipoSede", "is");
      },
    },
    {
      label: "B",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("B", "tipoSede", "is");
      },
    },
    {
      label: "B*",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("B*", "tipoSede", "is");
      },
    },
    {
      label: "C",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("C", "tipoSede", "is");
      },
    },
    {
      label: "D",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("D", "tipoSede", "is");
      },
    },
    {
      label: "COL",
      command: (event) => {
        this.pianiTecniciSanitaDT.filter("COL", "tipoSede", "is");
      },
    },
    {
      label: "TUTTE",
      command: (event) => {
        this.pianiTecniciSanitaDT.clear();
      },
    },
  ];

  constructor(
    private logger: NGXLogger,
    private googleStorageService: GoogleStorageService,
    private confirmationService: ConfirmationService,
    private praticheSanitaService: PraticheSanitaService,
    private messageService: MessageService,
    public dialogService: DialogService,
    public firestore: AngularFirestore,
    private router: Router,
    private excelService: ExcelService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private impreseService:ImpreseService,
    private csvboxLoaderService: CsvboxLoaderService,
    private pianoTecnicoSanitaService: PianoTecnicoSanitaService,

  ) {
    this.detectDevice();
    this.dialogConfig = {
      height: "600px",
      width: "600px",
      disableClose: true,
      data: {},
    };
   
  }

  detectDevice() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    this.isMobile = isMobile;
  }

  ngOnInit(): void {
    if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "ADMIN"
    ) {
      this.isAdmin = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "SUPERADMIN"
    ) {
      this.isSuperAdmin = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "SMARTFIBER"
    ) {
      this.isPresidioSF = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "PRESIDIO"
    ) {
      this.isPresidioTIM = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "OPERATORE_AZIENDA"
    ) {
      this.isImpresa = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_VERBALI"
    ) {
      this.isDirigenteFirmaVerbali = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_PACCHETTI"
    ) {
      this.isDirigenteFirmaPacchetti = true;
    }
  

    //this.loadMenuStatiPratica();

    this.loadCSVBox();
    this.loadAllPianiSanitaFromFirestore();
  }

  loadAzioni(event:any, pianoTecnico:PianoTecnicoSanita_Firestore) {
    this.menuAzioniItems = [];
    
    this.menuAzioniItems.push(
      {
        label: "Vai alle pratiche",
        icon: PrimeIcons.WINDOW_MAXIMIZE,
        style: { 'font-weight': 'bold', 'font-size': '13px'},
        command: () => this.apriPraticheDelPianoTecnico(pianoTecnico),
      } ,
      {
        label: "Modifica",
        icon: PrimeIcons.FILE_EDIT,
        style: { 'font-weight': 'bold', 'font-size': '13px'},
        command: () => this.modificaPianoTecnico(pianoTecnico),
      } ,
      {
        label: "Carica CMT",
        icon: PrimeIcons.FILE_IMPORT,
        style: { 'font-weight': 'bold', 'font-size': '13px'},
        command: () => this.caricaComputoMetrico(pianoTecnico),
      } 
    );
      
      if(pianoTecnico.completo ){ 
        this.menuAzioniItems.push(
          {
            label: "Genera RET",
            icon: PrimeIcons.FILE_WORD,
            style: {  'font-weight': 'bold', 'font-size': '13px'},
            command: () => this.generaRET(pianoTecnico),
            },
            {
              label: "Scarica Pacchetto",
              icon: PrimeIcons.DOWNLOAD,
              style: {  'font-weight': 'bold', 'font-size': '13px'},
              command: () => this.scaricaPacchettoPianoTecnico(pianoTecnico),
              },
        );
      }else{
        this.menuAzioniItems.push(
          {
            label: "Elimina",
            icon: PrimeIcons.ERASER,
            style: {  'font-weight': 'bold', 'font-size': '13px'},
            command: () => this.eliminaPianoTecnico(pianoTecnico),
            } 
        );
      }
     
      

     
      
    
   
  }
  applyHideClosedFilter() {
   // this.logger.info("--> applyHideClosedFilter "+ this.mostraAnnullate + " " + this.testoFiltroAnnullate);
   /*  if (this.mostraAnnullate) {
      this.testoFiltroAnnullate='NASCONDI ';
      this.mostraAnnullate = false;
      this.pianiTecniciSanitaDT.clear();
      
    } else {
      this.testoFiltroAnnullate='MOSTRA ';
      this.mostraAnnullate = true;
      this.pianiTecniciSanitaDT.filter("ANNULLATA", "stato", "isNot");
    } */
  }

  

  loadCSVBox(){
    this.csvboxLoaderService.loadScript().then(() => {
      this.csvbox_importer = new CSVBoxImporter(this.csvbox_licenseKey_importaPraticheSanita, {
        // Configuration options
      }, (result: boolean, data: any) => {
        if (result) {
          this.logger.info("Sheet uploaded successfully");
          this.logger.info(data.row_success + " rows uploaded");
          this.messageService.add({severity:'success', summary:'', detail: data.row_success + ' pratiche sanità importate con successo!', life:10000});
        } else {
          this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di import delle pratiche', life:10000});
          // Custom code
        }
      });

    
      this.csvbox_importer.setUser({
        user_id: "default123"
      });
      this.csvbox_importer.language="it";

    });

    
 
  }

  loadImprese(){
    this.isLoadingResults = true;
    this.impreseService.getByBando("2").subscribe((res) => {
      this.isLoadingResults = false;

      res.forEach(impresa => {
        if(impresa.ragioneSociale!=='Admin Fake Company'){
          this.imprese.push({
            label: impresa.ragioneSociale,
            command: (event) => {
              this.pianiTecniciSanitaDT.filter(impresa.ragioneSociale, "azienda", "is");
            },
          });
        }
          
      });
      this.imprese.push({
        label: "TUTTE",
        command: (event) => {
          this.pianiTecniciSanitaDT.clear();
        },
      });
    }); 
  }
  filtraPerNome(event: any) {
    this.pianiTecniciSanitaDT.filterGlobal(event.target.value, 'contains');
  }

  filtraPerStato(stato: String) {
    this.pianiTecniciSanitaDT.filter(stato, "stato", "is");
  }

  
 
  ngAfterViewInit() {}


  loadAllPianiSanitaFromFirestore() {
    this.isLoadingResults = true;
    const collectionRef = this.firestore.collection(this.collection_piani_tecnici_sanita).ref;
    const query = collectionRef
    //.where("bando", "==", "BANDO 2")
    //.where("stato", "!=", "ANNULLATA")
    .orderBy("descrizione");
    onSnapshot(query, (qs) => {
        this.pianiTecniciSanitaAtFirestore = [];
        this.isLoadingResults = false;
        this.logger.info(  "--> RISULTATO LOAD PIANI SANITA > " + qs.docs.length );
        qs.forEach((doc) => {
          let pratica = doc.data() as PianoTecnicoSanita_Firestore;
          this.pianiTecniciSanitaAtFirestore.push(pratica);
         
        });
        /* this.pianiTecniciSanitaDT.filter("ANNULLATA", "stato", "isNot");
        if(this.filterIsSet){
          if(this.filtroStato){
            this.logger.info(  "--> al risultato applico FILTRO PER STATO > " +this.filtroStato );

            this.pianiTecniciSanitaDT.filter(this.filtroStato, "stato", "is");
          }else if(this.filtroPratica){
            this.logger.info(  "--> al risultato applico FILTRO PER CODICE PRATICA > " +this.filtroPratica );

          }
          
        } */
    });
  }

  importaPianiTecnici(){
    this.logger.info("*** IMPORTA PIANI TECNICI SANITA*****");
    this.csvbox_importer.openModal();
  }

  

  creaPianoTecnico(){
       this.ref = this.dialogService.open(DialogCreaPianoTecnicoSanita, {
        data: {
        },
        header: "Creazione Piano Tecnico",
        width: this.isMobile ? "95%" : "85%",
        height: "85%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((infoUpdated) => {
        if (infoUpdated && infoUpdated.success) {
          this.messageService.add({
            severity: "success",
            summary: "" , life:10000,
            detail: "Piano Tecnico creato con successo"
          });
        }
      }); 
  }

  
  

  

  reloadDataRemovingFilter(){
    this.location.replaceState('/pratiche-scuola-sanita');
    this.filterIsSet = false;
    this.filtroPratica = null;
    this.filtroStato = null;
    this.pianiTecniciSanitaDT.clear();
    /* if (this.isAdmin || this.isSuperAdmin || this.isPresidioSF) {
      if(this.filterIsSet){
        this.loadAllPraticheSanitaFromFirestoreWithFilter();
      }else{
        this.loadAllPianiSanitaFromFirestore();
      }
    
    }else if(this.isPresidioTIM){
      if(this.filterIsSet){
        this.loadAllPraticheSanitaFromFirestoreWithFilter();
      }else{
        this.loadPraticheScuolaPresidioTIMFromFirestore();
      }
     
    }else if(this.isDirigenteFirmaVerbali){
      if(this.filterIsSet){
        this.loadAllPraticheSanitaFromFirestoreWithFilter();
      }else{
        this.loadPraticheScuolaDirigenteFirmaVerbaliFromFirestore();
      }
    }else if(this.isDirigenteFirmaPacchetti){
      if(this.filterIsSet){
        this.loadAllPraticheSanitaFromFirestoreWithFilter();
      }else{
        this.loadPraticheScuolaDirigenteFirmaPacchettiFromFirestore();
      }
    }else {
      this.loadPraticheSanitaPerAziendaFromFirestore();
    } */
  }


  

  
  openMandaAlPresidioTIM(pianoTecnico: PianoTecnicoSanita_Firestore) {
    //this.logger.info("---> openMandaAlPresidioTIM --> " + pratica.id);
    /* let messaggio = `Confermi di voler procedere con l'invio della pratica ${pratica.codiceInfratel} al PRESIDIO TIM?`;
    if(pratica.colocata){
      messaggio +=`<br>Trattandosi di pratica <b>colocata</b>, verranno inviate anche tutte le pratiche associate!`; 
    }
    this.confirmationService.confirm({
      message: messaggio,
      header: "Invia al PRESIDIO TIM",
      icon: "pi pi-File-import",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
        this.logger.info(localStorage.getItem("idUtente"));
        let praticaDaInviareAlPresidio: PraticaScuola = new PraticaScuola();
        praticaDaInviareAlPresidio.id = pratica.id;
        this.logger.info(praticaDaInviareAlPresidio);
        this.praticheSanitaService.inviaAlPresidio(praticaDaInviareAlPresidio).subscribe({
          next: (v) => {},
          error: (e) => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "info",
             summary: "Errore" , life:10000,
              detail: "Errore in fase di invio al presidio TIM della pratica",
            });
          },
          complete: () => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "success",
              summary: "" , life:10000,
              detail: "Pratica inviata con successo al presidio TIM",
            });
          },
        }); 
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    }); */
  }

  openStoricoPratica(pianoTecnico: PianoTecnicoSanita_Firestore) {
   /* this.isLoadingResults = true;
    this.storicoPraticheService.getStoricoPraticaSanitaById(pratica.id.toString()).subscribe(storicoPratica=>{
      this.isLoadingResults = false;
        if(storicoPratica && storicoPratica.length > 0){
          this.ref = this.dialogService.open(DialogStoricoPraticaSanita, {
            data: {
              pratica: pratica,
              storicoPratica: storicoPratica
            },
            header: "Storico della pratica "+pratica.codiceInfratel,
            width: this.isMobile ? "95%" : "90%",
            height: "35%",
            baseZIndex: 10000,
            closable: true,
            draggable: false,
          });
        }else{
          this.messageService.add({
            severity: "info",
            summary: "Attenzione!",
            detail: "La pratica non presenta STORICO",
          });
        }
    });  */
  }

  

  /* onPraticaSelection(pratica: PraticaSanita_Firestore) {
    if (this.selectedPratiche && this.selectedPratiche.length > 1) {
      this.disableSingleActionButtons = true;
    } else {
      this.disableSingleActionButtons = false;
    }
  }
  isDaAssegnare(pratica: PraticaSanita_Firestore): boolean {
   
    if (pratica.stato === "CARICATA") {
      return true;
    }
    return false;
  }
  iAssegnata(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "ASSEGNATA") {
      return true;
    }
    return false;
  }
  isInCaricoPresidioTIM(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "IN CARICO PRESIDIO") {
      return true;
    }
    return false;
  }
  isDaPrendereInCarico(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "ASSEGNATA") {
      return true;
    }
    return false;
  }

  isDaProgettare(pratica:PraticaSanita_Firestore): boolean {
    if (pratica.stato === "IN CARICO IMPRESA") {
      return true;
    }
    return false;
  }


  isInCarico(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "IN CARICO IMPRESA") {
      return true;
    }
    return false;
  }

  isInProgettazione(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "IN PROGETTAZIONE") {
      return true;
    }
    return false;
  }

  isProgettata(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.progettata && pratica.progettata === true) {
      return true;
    }
    return false;
  }

  isDeliverable(pratica: PraticaSanita_Firestore): boolean {
    if (
      pratica.stato === "IN PROGETTAZIONE" &&  pratica.fotoRouterUploaded && pratica.progettata
    ) {
      return true;
    }
    return false;
  }

  areDocsCreatable(pratica: PraticaSanita_Firestore): boolean {
    if (
      (pratica.stato === "IN PROGETTAZIONE" || pratica.stato === "IN REWORK AZIENDA") && 
      pratica.fotoRouterUploaded &&
      pratica.infoCompleted
    ) {
      return true;
    }
    return false;
  }

  

  isDelivered(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "CONSEGNATA") {
      return true;
    }
    return false;
  }
  isInRework(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "IN REWORK AZIENDA") {
      return true;
    }
    return false;
  }

  isSignable(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "IN CARICO PRESIDIO" && pratica.ordineEsecuzione && pratica.computoMetricoUploaded ) {
      return true;
    }
    return false;
  }

  isSigned(pratica: PraticaSanita_Firestore): boolean {
    this.logger.info("> isSigned " + pratica.stato)
    if (pratica.stato === "FIRMATA" ) {
      return true;
    }
    return false;
  }

  isPublished(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "PUBBLICATA" ) {
      return true;
    }
    return false;
  }

  isApproved(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "APPROVATA") {
      return true;
    }
    return false;
  }
  isRejected(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "RESPINTA") {
      return true;
    }
    return false;
  }
  isInVerbalSignState(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "IN FIRMA VERBALE") {
      return true;
    }
    return false;
  }
  isInSigningPackageState(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "VERBALE FIRMATO") {
      return true;
    }
    return false;
  }

  
  hasSignedVerbal(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "VERBALE FIRMATO") {
      return true;
    }
    return false;
  }
  hasSignedPackage(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "FIRMATA") {
      return true;
    }
    return false;
  }

  
  hasRejectionFile(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.noteRespingimentoFile &&  pratica.noteRespingimentoFile.length > 0) {
      return true;
    }
    return false;
  }
  hasReworkFile(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.noteReworkFile &&  pratica.noteReworkFile.length > 0) {
      return true;
    }
    return false;
  }
  
  isInCaricoPresidioSF(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "IN VERIFICA SMARTFIBER") {
      return true;
    }
    return false;
  }

  isVoidable(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.stato === "ASSEGNATA" ||  pratica.stato === "CARICATA" || pratica.stato === "IN CARICO IMPRESA") {
      return true;
    }
    return false;
  } 


  hasCoordinates(pratica: PraticaSanita_Firestore): boolean {
    if (pratica.coordinateAccesso) {
      return true;
    }

    return false;
  }
*/
  caricaPianiTecniciSanita() {
    this.csvbox_importer.openModal();
  }

  loadAzioniScaricaFile() {
    /* this.menuScaricaFileItems = [
      {
        label: "RET",
        icon: PrimeIcons.FILE_WORD,
        styleClass: "RETstyle",

        command: () => this.scaricaDocs("RET"),
      },
      {
        label: "PSI",
        icon: PrimeIcons.FILE_WORD,
        styleClass: "RETstyle",

        command: () => this.scaricaDocs("PSI"),
      },
      {
        label: "ALL.IRU",
        icon: PrimeIcons.FILE_WORD,
        styleClass: "RETstyle",
        command: () => this.scaricaDocs("IRU"),
      },
      {
        label: "TUTTI",
        icon: PrimeIcons.FILE_WORD,
        styleClass: "RETstyle",
        command: () => this.scaricaDocs("ALL"),
      },
    ]; */
  }
  loadAzioniRisultatoInvioPratica(pratica:PraticaSanita_Firestore){
    /* this.menuRisultatiInvioPraticaItems = [
      {
        label: "APPROVATA",
        icon: PrimeIcons.CHECK,
        styleClass: "valid-menu-item",
        command: () => this.openRisultatoAzioniConsegnaPratica(pratica, true),
      },
      {
        label: "RESPINTA",
        icon: PrimeIcons.TIMES,
        styleClass: "reject-menu-item",

        command: () => this.openRisultatoAzioniConsegnaPratica(pratica, false),
      },
    ]; */
  }


  openRisultatoAzioniConsegnaPratica(pratica:PraticaSanita_Firestore, isApprovata:boolean){
   /*  if(isApprovata){
      this.logger.info("--> PRATICA VALIDATA");
      this.isLoadingResults = true;
      this.praticheSanitaService
      .getById(pratica.id.toString())
      .subscribe((pratica) => {
        this.praticheSanitaService.comunicaApprovazionePratica(pratica).subscribe(res=>{
          this.isLoadingResults = false;
          this.messageService.add({
            severity: "success",
            summary: "" , life:10000,
            detail: "Pratica aggiornata con successo",
          });
        });
      });
      
    }else {
      this.logger.info("--> PRATICA RESPINTA");
      this.isLoadingResults = true;
      this.praticheSanitaService
      .getById(pratica.id.toString())
      .subscribe((pratica) => {
        this.ref = this.dialogService.open(DialogInserisciNoteRespingimentoPratica, {
          data: {
            pratica: pratica,
          },
          header: "Respingimento Pratica "+pratica.codiceInfratel,
          width: this.isMobile ? "95%" : "85%",
          height: "85%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
        this.ref.onClose.subscribe((infoUpdated) => {
          if (infoUpdated && infoUpdated.success) {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "success",
              summary: "" , life:10000,
              detail: "Pratica aggiornata con successo",
            });
          }
        });
        })
      
    } */

  }
  

  

  loadAzioniCaricaFile(pratica:PraticaSanita_Firestore) {
    /* this.menuCaricaFileItems = [
      {
        label: "FOTO ROUTER",
        icon: PrimeIcons.CAMERA,
        command: () => this.openCaricaFotoRouter(pratica),
      },
      {
        label: "PLANIMETRIA",
        icon: PrimeIcons.IMAGE,
        command: () => this.openCaricaPlanimetria(pratica),
      },
      {
        label: "NT9",
        icon: PrimeIcons.BUILDING,
        command: () => this.openCaricaPacchettoNT9(pratica),
      }
    ]; */
  }

  showPulsante(pratica:PraticaSanita_Firestore):boolean{
    if(this.isDirigenteFirmaPacchetti && pratica.colocataRuolo==='SECONDARIA'){
      return false;
    }
    return true;
  }

  async scaricaDocs(action: string) {
   /*  const storage = getStorage();
    if (action === "RET") {
      if(!this.selectedPraticaAtFirestore.colocata || this.selectedPraticaAtFirestore.colocataRuolo ==='PRINCIPALE'){
        const pathReferenceRET = ref(
          storage,
          "pratiche/scuola/" +
            this.selectedPraticaAtFirestore.codiceInfratel +
            "/OUT/"+this.selectedPraticaAtFirestore.codiceRegione+"_F_RET_01_0.docx"
        );
  
        const blobRET = await getBlob(pathReferenceRET);
        saveAs(blobRET, this.selectedPraticaAtFirestore.codiceRegione+"_F_RET_01_0.docx");
      }else{
        const pathReferenceRET = ref(
          storage,
          "pratiche/scuola/" +
            this.selectedPraticaAtFirestore.colocataScuolaPrincipale +
            "/OUT/"+this.selectedPraticaAtFirestore.codiceRegione+"_F_RET_01_0.docx"
        );
  
        const blobRET = await getBlob(pathReferenceRET);
        saveAs(blobRET, this.selectedPraticaAtFirestore.codiceRegione+"_F_RET_01_0.docx");
      }
      
    } else if (action === "PSI") {
      if(!this.selectedPraticaAtFirestore.colocata || this.selectedPraticaAtFirestore.colocataRuolo ==='PRINCIPALE'){
        const pathReferencePSI = ref(
          storage,
          "pratiche/scuola/" +
            this.selectedPraticaAtFirestore.codiceInfratel +
            "/OUT/"+this.selectedPraticaAtFirestore.codiceRegione+"_F_PSI_02_0.docx"
        );
  
        const blobPSI = await getBlob(pathReferencePSI);
        saveAs(blobPSI, this.selectedPraticaAtFirestore.codiceRegione+"_F_PSI_02_0.docx");
      }else{
        const pathReferencePSI = ref(
          storage,
          "pratiche/scuola/" +
            this.selectedPraticaAtFirestore.colocataScuolaPrincipale +
            "/OUT/"+this.selectedPraticaAtFirestore.codiceRegione+"_F_PSI_02_0.docx"
        );
  
        const blobPSI = await getBlob(pathReferencePSI);
        saveAs(blobPSI, this.selectedPraticaAtFirestore.codiceRegione+"_F_PSI_02_0.docx");
      }
     
    } else if (action === "IRU") {

      const pathReferencePSI = ref(
        storage,
        "pratiche/scuola/" +
          this.selectedPraticaAtFirestore.codiceInfratel +
          "/OUT/ALLEGATO CONTRATTO IRU_" +
          this.selectedPraticaAtFirestore.codiceInfratel +
          ".docx"
      );

      const blobPSI = await getBlob(pathReferencePSI);
      saveAs(
        blobPSI,
        "ALLEGATO CONTRATTO IRU_" +
          this.selectedPraticaAtFirestore.codiceInfratel +
          ".docx"
      );
    } else if (action === "ALL") {
      if(!this.selectedPraticaAtFirestore.colocata || this.selectedPraticaAtFirestore.colocataRuolo ==='PRINCIPALE'){
        const pathReferenceRET = ref(
          storage,
          "pratiche/scuola/" +
            this.selectedPraticaAtFirestore.codiceInfratel +
            "/OUT/"+this.selectedPraticaAtFirestore.codiceRegione+"_F_RET_01_0.docx"
        );
  
        const blobRET = await getBlob(pathReferenceRET);
        saveAs(blobRET, this.selectedPraticaAtFirestore.codiceRegione+"_F_RET_01_0.docx");
      }else{
        const pathReferenceRET = ref(
          storage,
          "pratiche/scuola/" +
            this.selectedPraticaAtFirestore.colocataScuolaPrincipale +
            "/OUT/"+this.selectedPraticaAtFirestore.codiceRegione+"_F_RET_01_0.docx"
        );
  
        const blobRET = await getBlob(pathReferenceRET);
        saveAs(blobRET, this.selectedPraticaAtFirestore.codiceRegione+"_F_RET_01_0.docx");
      }

      if(!this.selectedPraticaAtFirestore.colocata || this.selectedPraticaAtFirestore.colocataRuolo ==='PRINCIPALE'){
        const pathReferencePSI = ref(
          storage,
          "pratiche/scuola/" +
            this.selectedPraticaAtFirestore.codiceInfratel +
            "/OUT/"+this.selectedPraticaAtFirestore.codiceRegione+"_F_PSI_02_0.docx"
        );
  
        const blobPSI = await getBlob(pathReferencePSI);
        saveAs(blobPSI, this.selectedPraticaAtFirestore.codiceRegione+"_F_PSI_02_0.docx");
      }else{
        const pathReferencePSI = ref(
          storage,
          "pratiche/scuola/" +
            this.selectedPraticaAtFirestore.colocataScuolaPrincipale +
            "/OUT/"+this.selectedPraticaAtFirestore.codiceRegione+"_F_PSI_02_0.docx"
        );
  
        const blobPSI = await getBlob(pathReferencePSI);
        saveAs(blobPSI, this.selectedPraticaAtFirestore.codiceRegione+"_F_PSI_02_0.docx");
      }

      const pathReferenceAllegatoIRU = ref(
        storage,
        "pratiche/scuola/" +
          this.selectedPraticaAtFirestore.codiceInfratel +
          "/OUT/ALLEGATO CONTRATTO IRU_" +
          this.selectedPraticaAtFirestore.codiceInfratel +
          ".docx"
      );

      const blobAllegatoIRU = await getBlob(pathReferenceAllegatoIRU);
      saveAs(
        blobAllegatoIRU,
        "ALLEGATO CONTRATTO IRU_" +
          this.selectedPraticaAtFirestore.codiceInfratel +
          ".docx"
      );
    } */
  }
  openCaricaPacchettoFirmato(pratica:PraticaSanita_Firestore){
    this.logger.info("--carica pacchetto");
    /**
      1) APRIRE LA MODALE
      2) SE CARICAMENTO OK > MODIFICO DATO SU FIRESTORE E/O CHIAMO ENDPOINT
      3) CAMBIO LO STATO ?
    */
  }

  getColocataFontClass(pratica: PraticaSanita_Firestore): string {
    if(!pratica.colocata){
      return '';
    }else{
      if(pratica.colocataRuolo==='PRINCIPALE'){
        return 'colocata-principale-text';
      }
    }
    return 'colocata-secondaria-text';
  }
  
  getColocataClass(pratica: PraticaSanita_Firestore):string{
    if(!pratica.colocata){
      return '';
    }else{
      if(pratica.colocataRuolo==='PRINCIPALE'){
        return 'text-blu-900 pi-check';
      }
    }
    return 'text-green-700 pi-check';
    /*
    'text-green-700 pi-check': (row.colocata && row.colocataRuolo == 'PRINCIPALE'),
              'text-red-700 pi-check': (row.colocata && row.colocataRuolo == 'SECONDARIA'),
              '': !row.colocata
    */
     

  }
  openMandaInFirma(pratica: PraticaSanita_Firestore) {}

  async scaricaFileRespingimentoPratica(pratica: PraticaSanita_Firestore) {
    /* this.logger.info("---> SCARICO File RESPINGIMENTO DELLA PRATICA "+pratica.codiceInfratel);
    const storage = getStorage();
    const pathReferenceFileRespingimento                    = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/IN/"+pratica.noteRespingimentoFile);
    const blob = await getBlob(pathReferenceFileRespingimento);
    saveAs(blob, pratica.noteRespingimentoFile); */
  }

  async scaricaVerbale(pratica: PraticaSanita_Firestore, isBulk:boolean) {
    /* this.logger.info("-scaricaVerbale "+ pratica.ha2Tratte);
    if(!isBulk){
      this.confirmationService.confirm({
        message: `Non rinominare i file che si stanno scaricando durante il processo di firma!`,
        header: "ATTENZIONE!",
        icon: "pi pi-exclamation-circle",
        acceptLabel: "PROCEDI",
        acceptButtonStyleClass: "p-button-success",
        rejectLabel: "ANNULLA",
        rejectButtonStyleClass: "p-button-warning",
        accept: async () => {
          const storage = getStorage();
          const pathReferenceFileVerbale    = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/Contratto_Cessione_IRU_"+pratica.codiceInfratel+".pdf");
         
          try {
            const blob = await getBlob(pathReferenceFileVerbale);
            saveAs(blob, "Contratto_Cessione_IRU_"+pratica.codiceInfratel+".pdf");

            if(pratica.tipoSede==='D' && pratica.ha2Tratte){
              this.logger.info("-DOVREI PROVARE A SCARICARE ANCHE IL VERBALE NUOVE PROPRIETA  ");
              const pathReferenceFileVerbaleTratta2    = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/Contratto_Cessione_Proprietà_Nuove_Infrastrutture_"+pratica.codiceInfratel+".pdf");
              const blobTratta2 = await getBlob(pathReferenceFileVerbaleTratta2);
              saveAs(blobTratta2, "Contratto_Cessione_Proprietà_Nuove_Infrastrutture_"+pratica.codiceInfratel+".pdf");
            }
          } catch (error) {
            if (error.code === 'storage/object-not-found') {
              this.logger.info('Il file non esiste:', error.message);
              this.messageService.add({
                severity: "info",
               summary: "Errore" , life:10000,
                detail: "Verbale cessione IRU NON esistente",
              });
            } else {
              // Gestisci altri tipi di errori
              this.logger.info('Errore sconosciuto:', error);
            }
          }
        },
        reject: () => {
        },
      });
    }else{
      const storage = getStorage();
          const pathReferenceFileVerbale                    = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/Contratto_Cessione_IRU_"+pratica.codiceInfratel+".pdf");
          try {
            const blob = await getBlob(pathReferenceFileVerbale);
            saveAs(blob, "Contratto_Cessione_IRU_"+pratica.codiceInfratel+".pdf");
            if(pratica.tipoSede==='D' && pratica.ha2Tratte){
              const pathReferenceFileVerbaleTratta2    = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/Contratto_Cessione_Proprietà_Nuove_Infrastrutture_"+pratica.codiceInfratel+".pdf");
              const blobTratta2 = await getBlob(pathReferenceFileVerbaleTratta2);
              saveAs(blobTratta2, "Contratto_Cessione_Proprietà_Nuove_Infrastrutture_"+pratica.codiceInfratel+".pdf");
            }
          } catch (error) {
            if (error.code === 'storage/object-not-found') {
              this.logger.info('Il file non esiste:', error.message);
              this.messageService.add({
                severity: "info",
               summary: "Errore" , life:10000,
                detail: "Verbale cessione IRU NON esistente",
              });
            } else {
              // Gestisci altri tipi di errori
              this.logger.info('Errore sconosciuto:', error);
            }
          }
    }
     */
    

  }

  async scaricaShape(pratica: PraticaSanita_Firestore) {
    /* this.logger.info("---> SCARICO SHAPE DA FIRMARE DELLA PRATICA "+pratica.codiceInfratel.substring(10,pratica.codiceInfratel.length));
    const storage = getStorage();
    const pathReferencePacchetto                    = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/IN/nt9.zip");
    try {
      const blob = await getBlob(pathReferencePacchetto);
      saveAs(blob, "AB_"+pratica.codiceInfratel.substring(10,pratica.codiceInfratel.length)+".zip");
    } catch (error) {
      if (error.code === 'storage/object-not-found') {
        this.logger.info('Il file non esiste:', error.message);
        this.messageService.add({
          severity: "info",
         summary: "Errore" , life:10000,
          detail: "File nt9 NON esistente",
        });
      } else {
        // Gestisci altri tipi di errori
        this.logger.info('Errore sconosciuto:', error);
      }
    }
    */
    
    
  }
  async scaricaPacchetto(pratica: PraticaSanita_Firestore) {
    this.logger.info("---> SCARICO PACCHETTO DA FIRMARE DELLA PRATICA "+pratica.codiceInfratel);
    /* this.confirmationService.confirm({
      message: `Non rinominare i file che si stanno scaricando durante il processo di firma!`,
      header: "ATTENZIONE!",
      icon: "pi pi-exclamation-circle",
      acceptLabel: "PROCEDI",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: async () => {
        const storage = getStorage();
        const pathReferencePacchetto                    = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/Contratto_Cessione_IRU_"+pratica.codiceInfratel+".pdf");
        try {
          const blob = await getBlob(pathReferencePacchetto);
          saveAs(blob, "Contratto_Cessione_IRU_"+pratica.codiceInvio+".pdf");
        }catch (error) {
          if (error.code === 'storage/object-not-found') {
            this.logger.info('Il file non esiste:', error.message);
            this.messageService.add({
              severity: "info",
             summary: "Errore" , life:10000,
              detail: "Verbale cessione IRU NON esistente",
            });
          } else {
            // Gestisci altri tipi di errori
            this.logger.info('Errore sconosciuto:', error);
          }
        }
        
      },
      reject: () => {
      },
    }); */

    

  }

  async scaricaFileReworkPratica(pratica: PraticaSanita_Firestore) {
    this.logger.info("---> SCARICO File REWORK DELLA PRATICA "+pratica.codiceInfratel);
   /*  const storage = getStorage();
    const pathReferenceFileRework                    = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/IN/"+pratica.noteReworkFile);
    const blob = await getBlob(pathReferenceFileRework);
    saveAs(blob, pratica.noteReworkFile); */
  }

  async scaricaPacchettoFirmato(pratica: PraticaSanita_Firestore){

   /*  if(!pratica.colocata){
      this.logger.info("---> scaricaPacchettoPratica FIRMATA non colocata");

      this.openScaricaPacchettoFirmatoPratica(pratica);
    }else{
      this.logger.info("---> scaricaPacchettoPratica FIRMATAcolocata");

      this.openScaricaPacchettoFirmatoPratica(pratica);
    } */
  }

  async scaricaPacchettoPratica(pratica: PraticaSanita_Firestore, isBulk:boolean){

    /* if(!pratica.colocata){
      this.openScaricaPacchettoPratica(pratica, isBulk);
    }else{
      this.openScaricaPacchettoPraticaColocata(pratica, isBulk);
    } */
  }

  async scaricaPreviewDocsPraticaColocata(pratica: PraticaSanita_Firestore){
    this.logger.info("---> SCARICO LA PREVIEW DEI DOCS DELLA PRATICA COLOCATA "+pratica.codiceInfratel + " con codiceInvio "+ pratica.codiceInvio);
    /* this.isLoadingResults = true;
    let praticaColocata:PraticaSanita_Firestore = null;
    const collectionRef = this.firestore.collection(this.collection_pratiche_sanita).ref;
    const query = collectionRef .where("colocataScuolaPrincipale", "==", pratica.codiceInfratel);
    onSnapshot(query, async (qs) => {
          this.logger.info(  "--> RISULTATO GET COLOCATA " + qs.docs.length );
          if( qs.size==1){
            praticaColocata = qs.docs[0].data() as PraticaSanita_Firestore;
            this.logger.info("---> HA SECONDARIA "+praticaColocata.codiceInfratel);
            const storage = getStorage();
            const zip = new JSZip();
            const pathReferenceRET                    = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/"+pratica.codiceRegione +"_F_RET_01_0.docx");
            const pathReferencePSI                    = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/"+pratica.codiceRegione +"_F_PSI_02_0.docx");
            const pathReferenceAllegatoIRUPrincipale            = ref( storage, "pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/ALLEGATO CONTRATTO IRU_" + pratica.codiceInfratel + ".docx" );
            const pathReferenceAllegatoIRUSecondaria            = ref( storage, "pratiche/scuola/" +  praticaColocata.codiceInfratel +"/OUT/ALLEGATO CONTRATTO IRU_" + praticaColocata.codiceInfratel + ".docx" );
            
            let filesToDownload = [
                pathReferenceRET,
                pathReferencePSI,
                pathReferenceAllegatoIRUPrincipale, 
                pathReferenceAllegatoIRUSecondaria, 
              ];
        
            const downloadPromises = [];
            for (const pathRef of filesToDownload) {
              this.logger.info(pathRef.name + " @ " + pathRef.fullPath);
              const blob = await getBlob(pathRef);
               
              if (blob) {
                zip.file(pathRef.name, blob);
                
                downloadPromises.push(Promise.resolve());
                
              } else {
                this.logger.info(`Errore durante il download di ${pathRef.name}`);
              }  
            }
            
            Promise.all(downloadPromises)
            .then(() => {
              zip.generateAsync({ type: 'blob' })
                .then((blob) => {
                  saveAs(blob, pratica.codiceInfratel+'.zip'); // Scarica il File zip
                  this.isLoadingResults = false;
                })
                .catch(error => this.logger.info('Errore durante la creazione dello zip:', error));
            })
            .catch(error => this.logger.info('Errore durante il download dei File:', error));
            this.isLoadingResults = false;
          }else{
            this.isLoadingResults = false;
          }
        
    }); */
  }

  async openScaricaPacchettoPraticaColocata(pratica: PraticaSanita_Firestore, isBulk:boolean) {
    this.logger.info("---> SCARICO TUTTO IL PACCHETTO DELLA PRATICA COLOCATA "+pratica.codiceInfratel + " con codiceInvio "+ pratica.codiceInvio);

    /* if(!isBulk){

    this.confirmationService.confirm({
      message: `Non rinominare i file che si stanno scaricando durante il processo di firma!`,
      header: "ATTENZIONE!",
      icon: "pi pi-exclamation-circle",
      acceptLabel: "PROCEDI",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: async () => {
          this.isLoadingResults = true;
          let praticaColocata:PraticaSanita_Firestore = null;
          const collectionRef = this.firestore.collection(this.collection_pratiche_sanita).ref;
          const query = collectionRef .where("colocataScuolaPrincipale", "==", pratica.codiceInfratel);
          onSnapshot(query, async (qs) => {
          
          this.logger.info(  "--> RISULTATO GET COLOCATA " + qs.docs.length );
          if( qs.size==1){
            praticaColocata = qs.docs[0].data() as PraticaSanita_Firestore;
            const storage = getStorage();
            const zip = new JSZip();
            const pathReferenceNT9Principale                    = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/IN/nt9.zip");
            const pathReferenceNT9Secondaria                    = ref( storage, "pratiche/scuola/" + praticaColocata.codiceInfratel +  "/IN/nt9.zip");
            const pathReferenceRET                              = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/"+pratica.codiceRegione+"_F_RET_01_0.pdf");
            const pathReferencePSI                              = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/"+pratica.codiceRegione+"_F_PSI_02_0.pdf");
            const pathReferenceCMT                    = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/"+pratica.codiceRegione+"_F_CMT_03_0.xlsx");
   
            const pathReferenceAllegatoIRUPrincipale            = ref( storage, "pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/ALLEGATO CONTRATTO IRU_" + pratica.codiceInfratel + ".pdf" );
            const pathReferenceAllegatoIRUSecondaria            = ref( storage, "pratiche/scuola/" +  praticaColocata.codiceInfratel +"/OUT/ALLEGATO CONTRATTO IRU_" + praticaColocata.codiceInfratel + ".pdf" );
            const pathReferenceVerbaleCessioneIRUPrincipale     = ref( storage, "pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/Contratto_Cessione_IRU_" + pratica.codiceInfratel + ".pdf.p7m" );
            const pathReferenceVerbaleCessioneIRUSecondaria     = ref( storage, "pratiche/scuola/" +  praticaColocata.codiceInfratel +"/OUT/Contratto_Cessione_IRU_" + praticaColocata.codiceInfratel + ".pdf.p7m" );
            
            //const pathReferenceVerbaleCessioneIRU     = ref( storage, "pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/Contratto_Cessione_IRU_" + pratica.codiceInfratel + ".p7m" );

            
            let filesToDownload = [
                pathReferenceNT9Principale, 
                pathReferenceNT9Secondaria, 
                pathReferenceRET,
                pathReferencePSI,
                pathReferenceCMT,
                pathReferenceAllegatoIRUPrincipale, 
                pathReferenceAllegatoIRUSecondaria, 
                pathReferenceVerbaleCessioneIRUPrincipale,
                pathReferenceVerbaleCessioneIRUSecondaria
              ];
        
            const downloadPromises = [];
            for (const pathRef of filesToDownload) {
              this.logger.info(pathRef.name + " @ " + pathRef.fullPath);
              try {
                const blob = await getBlob(pathRef);
                if (blob) {
                
                  if(pathRef.name===pratica.codiceRegione+'_F_RET_01_0.pdf' || pathRef.name===pratica.codiceRegione+'_F_PSI_02_0.pdf' || pathRef.name===pratica.codiceRegione+"_F_CMT_03_0.xlsx"){
                    zip.file(pathRef.name, blob);
                  }else if( pathRef.fullPath ==="pratiche/scuola/" + pratica.codiceInfratel +  "/IN/nt9.zip"){
                    zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_SHP_04_0").file(pratica.codiceInfratel.substring(pratica.codiceInfratel.length-15,pratica.codiceInfratel.length)+".zip", blob);
                  }else if( pathRef.fullPath ==="pratiche/scuola/" + praticaColocata.codiceInfratel +  "/IN/nt9.zip"){
                    zip.folder(praticaColocata.codiceInfratel+"/"+praticaColocata.codiceRegione+"_F_SHP_04_0").file(praticaColocata.codiceInfratel.substring(praticaColocata.codiceInfratel.length-15,praticaColocata.codiceInfratel.length)+".zip", blob);
  
                  }else if( pathRef.fullPath ==="pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/ALLEGATO CONTRATTO IRU_" + pratica.codiceInfratel + ".pdf"){
                      zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/contratto di cessione").file(pathRef.name, blob);
                  }else if( pathRef.fullPath ==="pratiche/scuola/" +  praticaColocata.codiceInfratel +"/OUT/ALLEGATO CONTRATTO IRU_" + praticaColocata.codiceInfratel + ".pdf"){
                      zip.folder(praticaColocata.codiceInfratel+"/"+praticaColocata.codiceRegione+"_F_ANN_05_0/contratto di cessione").file(pathRef.name, blob);
                  }else if( pathRef.fullPath ==="pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/Contratto_Cessione_IRU_" + pratica.codiceInfratel + ".pdf.p7m"){
                      zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/contratto di cessione").file(pathRef.name, blob);
                  }else if( pathRef.fullPath ==="pratiche/scuola/" +  praticaColocata.codiceInfratel +"/OUT/Contratto_Cessione_IRU_" + praticaColocata.codiceInfratel + ".pdf.p7m"){
                    zip.folder(praticaColocata.codiceInfratel+"/"+praticaColocata.codiceRegione+"_F_ANN_05_0/contratto di cessione").file(pathRef.name, blob);
                }
                  
                 
                  downloadPromises.push(Promise.resolve());
                  
                } else {
                  this.logger.info(`Errore durante il download di ${pathRef.name}`);
                }  
              } catch (error) {
                this.isLoadingResults = false;
                if (error.code === 'storage/object-not-found') {
                  this.logger.info('Il file non esiste:', error.message);
                  this.messageService.add({
                    severity: "info",
                   summary: "Errore" , life:10000,
                    detail: "Il file "+ error.message+" non esiste",
                  });
                } else {
                  // Gestisci altri tipi di errori
                  this.logger.info('Errore sconosciuto:', error);
                }
              }

            }
            
            Promise.all(downloadPromises)
            .then(() => {
              zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/documentazione fotografica");
              zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/istanze_autorizzazioni");
              zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/misure ottiche (eventuale)");
              zip.folder(praticaColocata.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/documentazione fotografica");
              zip.folder(praticaColocata.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/istanze_autorizzazioni");
              zip.folder(praticaColocata.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/misure ottiche (eventuale)");
              // Crea il File zip e avvia il download:
              zip.generateAsync({ type: 'blob' })
                .then((blob) => {
                  saveAs(blob, pratica.codiceInvio+'.zip'); // Scarica il File zip
                })
                .catch(error => this.logger.info('Errore durante la creazione dello zip:', error));
            })
            .catch(error => this.logger.info('Errore durante il download dei File:', error));
            this.isLoadingResults = false;
          }else{
            this.isLoadingResults = false;
          }
        
       });
        
      },
      reject: () => {
      },
    });
  }else{
    this.isLoadingResults = true;
          let praticaColocata:PraticaSanita_Firestore = null;
          const collectionRef = this.firestore.collection(this.collection_pratiche_sanita).ref;
          const query = collectionRef .where("colocataScuolaPrincipale", "==", pratica.codiceInfratel);
          onSnapshot(query, async (qs) => {
          
          this.logger.info(  "--> RISULTATO GET COLOCATA " + qs.docs.length );
          if( qs.size==1){
            praticaColocata = qs.docs[0].data() as PraticaSanita_Firestore;
            const storage = getStorage();
            const zip = new JSZip();
            const pathReferenceNT9Principale                    = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/IN/nt9.zip");
            const pathReferenceNT9Secondaria                    = ref( storage, "pratiche/scuola/" + praticaColocata.codiceInfratel +  "/IN/nt9.zip");
            const pathReferenceRET                              = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/"+pratica.codiceRegione+"_F_RET_01_0.pdf");
            const pathReferencePSI                              = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/"+pratica.codiceRegione+"_F_PSI_02_0.pdf");
            const pathReferenceCMT                    = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/"+pratica.codiceRegione+"_F_CMT_03_0.xlsx");
   
            const pathReferenceAllegatoIRUPrincipale            = ref( storage, "pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/ALLEGATO CONTRATTO IRU_" + pratica.codiceInfratel + ".pdf" );
            const pathReferenceAllegatoIRUSecondaria            = ref( storage, "pratiche/scuola/" +  praticaColocata.codiceInfratel +"/OUT/ALLEGATO CONTRATTO IRU_" + praticaColocata.codiceInfratel + ".pdf" );
            const pathReferenceVerbaleCessioneIRUPrincipale     = ref( storage, "pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/Contratto_Cessione_IRU_" + pratica.codiceInfratel + ".pdf.p7m" );
            const pathReferenceVerbaleCessioneIRUSecondaria     = ref( storage, "pratiche/scuola/" +  praticaColocata.codiceInfratel +"/OUT/Contratto_Cessione_IRU_" + praticaColocata.codiceInfratel + ".pdf.p7m" );
            
            //const pathReferenceVerbaleCessioneIRU     = ref( storage, "pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/Contratto_Cessione_IRU_" + pratica.codiceInfratel + ".p7m" );

            
            let filesToDownload = [
                pathReferenceNT9Principale, 
                pathReferenceNT9Secondaria, 
                pathReferenceRET,
                pathReferencePSI,
                pathReferenceCMT,
                pathReferenceAllegatoIRUPrincipale, 
                pathReferenceAllegatoIRUSecondaria, 
                pathReferenceVerbaleCessioneIRUPrincipale,
                pathReferenceVerbaleCessioneIRUSecondaria
              ];
        
            const downloadPromises = [];
            for (const pathRef of filesToDownload) {
              this.logger.info(pathRef.name + " @ " + pathRef.fullPath);
              try {
                const blob = await getBlob(pathRef);
                if (blob) {
                
                  if(pathRef.name===pratica.codiceRegione+'_F_RET_01_0.pdf' || pathRef.name===pratica.codiceRegione+'_F_PSI_02_0.pdf' || pathRef.name===pratica.codiceRegione+"_F_CMT_03_0.xlsx"){
                    zip.file(pathRef.name, blob);
                  }else if( pathRef.fullPath ==="pratiche/scuola/" + pratica.codiceInfratel +  "/IN/nt9.zip"){
                    zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_SHP_04_0").file(pratica.codiceInfratel.substring(pratica.codiceInfratel.length-15,pratica.codiceInfratel.length)+".zip", blob);
                  }else if( pathRef.fullPath ==="pratiche/scuola/" + praticaColocata.codiceInfratel +  "/IN/nt9.zip"){
                    zip.folder(praticaColocata.codiceInfratel+"/"+praticaColocata.codiceRegione+"_F_SHP_04_0").file(praticaColocata.codiceInfratel.substring(praticaColocata.codiceInfratel.length-15,praticaColocata.codiceInfratel.length)+".zip", blob);
  
                  }else if( pathRef.fullPath ==="pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/ALLEGATO CONTRATTO IRU_" + pratica.codiceInfratel + ".pdf"){
                      zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/contratto di cessione").file(pathRef.name, blob);
                  }else if( pathRef.fullPath ==="pratiche/scuola/" +  praticaColocata.codiceInfratel +"/OUT/ALLEGATO CONTRATTO IRU_" + praticaColocata.codiceInfratel + ".pdf"){
                      zip.folder(praticaColocata.codiceInfratel+"/"+praticaColocata.codiceRegione+"_F_ANN_05_0/contratto di cessione").file(pathRef.name, blob);
                  }else if( pathRef.fullPath ==="pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/Contratto_Cessione_IRU_" + pratica.codiceInfratel + ".pdf.p7m"){
                      zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/contratto di cessione").file(pathRef.name, blob);
                  }else if( pathRef.fullPath ==="pratiche/scuola/" +  praticaColocata.codiceInfratel +"/OUT/Contratto_Cessione_IRU_" + praticaColocata.codiceInfratel + ".pdf.p7m"){
                    zip.folder(praticaColocata.codiceInfratel+"/"+praticaColocata.codiceRegione+"_F_ANN_05_0/contratto di cessione").file(pathRef.name, blob);
                }
                  
                 
                  downloadPromises.push(Promise.resolve());
                  
                } else {
                  this.logger.info(`Errore durante il download di ${pathRef.name}`);
                }  
              } catch (error) {
                this.isLoadingResults = false;
                if (error.code === 'storage/object-not-found') {
                  this.logger.info('Il file non esiste:', error.message);
                  this.messageService.add({
                    severity: "info",
                   summary: "Errore" , life:10000,
                    detail: "Il file "+ error.message+" non esiste",
                  });
                } else {
                  // Gestisci altri tipi di errori
                  this.logger.info('Errore sconosciuto:', error);
                }
              }

            }
            
            Promise.all(downloadPromises)
            .then(() => {
              zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/documentazione fotografica");
              zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/istanze_autorizzazioni");
              zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/misure ottiche (eventuale)");
              zip.folder(praticaColocata.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/documentazione fotografica");
              zip.folder(praticaColocata.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/istanze_autorizzazioni");
              zip.folder(praticaColocata.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/misure ottiche (eventuale)");
              // Crea il File zip e avvia il download:
              zip.generateAsync({ type: 'blob' })
                .then((blob) => {
                  saveAs(blob, pratica.codiceInvio+'.zip'); // Scarica il File zip
                })
                .catch(error => this.logger.info('Errore durante la creazione dello zip:', error));
            })
            .catch(error => this.logger.info('Errore durante il download dei File:', error));
            this.isLoadingResults = false;
          }else{
            this.isLoadingResults = false;
          }
        
       });
  } */
    

  }

  async openScaricaPacchettoFirmatoPratica(pratica: PraticaSanita_Firestore) {
    this.logger.info("---> SCARICO IL PACCHETTO FIRMATO DELLA PRATICA "+pratica.codiceInfratel);
    /* this.confirmationService.confirm({
      message: `Confermi di voler procedere con lo scaricamento del pacchetto della pratica ${pratica.codiceInfratel}? L'operazione indicherà che la pratica è stata inoltrata al cliente!`,
      header: "Scarica pacchetto firmato",
      icon: "pi pi-file-import",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: async () => {
        this.isLoadingResults = true;
        const storage = getStorage();
        const pathReferenceSignedZip = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/SIGNED/"+pratica.codiceInvio+".zip.p7m");
          
        let filesToDownload = [
          pathReferenceSignedZip,  
          ];
          
        for (const pathRef of filesToDownload) {
          try {
            const blob = await getBlob(pathRef);
            if (blob) {
              this.logger.info(pathRef.name); 
              saveAs(blob, pathRef.name); 
              this.praticheSanitaService.pubblicazionePratica(pratica.id).subscribe(res=>{
              });
              this.isLoadingResults = false;
            } else {
              this.logger.info(`Errore durante il download di ${pathRef.name}`);
            }
          }catch(error){
            this.isLoadingResults = false;
            if (error.code === 'storage/object-not-found') {
              this.logger.info('Il file non esiste:', error.message);
              this.messageService.add({
                severity: "info",
              summary: "Errore" , life:10000,
                detail: "Il file "+ error.message+" non esiste",
              });
            } else {
              // Gestisci altri tipi di errori
              this.logger.info('Errore sconosciuto:', error);
            }
          }
        }
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    }); */
         

  }

  async openScaricaPacchettoPratica(pratica: PraticaSanita_Firestore, isBulk:boolean) {
    this.logger.info("---> SCARICO TUTTO IL PACCHETTO DELLA PRATICA "+pratica.codiceInfratel);
    /* if(!isBulk){
      this.confirmationService.confirm({
        message: `Non rinominare i file che si stanno scaricando durante il processo di firma!`,
        header: "ATTENZIONE!",
        icon: "pi pi-exclamation-circle",
        acceptLabel: "PROCEDI",
        acceptButtonStyleClass: "p-button-success",
        rejectLabel: "ANNULLA",
        rejectButtonStyleClass: "p-button-warning",
        accept: async () => {
          this.isLoadingResults = true;
          const storage = getStorage();
          const zip = new JSZip();
          const pathReferenceNT9                       = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/IN/nt9.zip");
          const pathReferenceRET                       = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/"+pratica.codiceRegione+"_F_RET_01_0.pdf");
          const pathReferencePSI                       = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/"+pratica.codiceRegione+"_F_PSI_02_0.pdf");
          const pathReferenceCMT                       = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/"+pratica.codiceRegione+"_F_CMT_03_0.xlsx");
          const pathReferenceAllegatoIRU               = ref( storage, "pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/ALLEGATO CONTRATTO IRU_" + pratica.codiceInfratel + ".pdf" );
          const pathReferenceVerbaleCessioneIRU        = ref( storage, "pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/SIGNED/Contratto_Cessione_IRU_" + pratica.codiceInfratel + ".pdf.p7m" );  
          const pathReferenceVerbaleCessioneProprieta  = ref( storage, "pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/SIGNED/Contratto_Cessione_Proprieta_Nuove_Infrastrutture_" + pratica.codiceInfratel + ".pdf.p7m" );
          let filesToDownload = [
              pathReferenceNT9, 
              pathReferenceRET,
              pathReferencePSI,
              pathReferenceCMT,
              pathReferenceAllegatoIRU, 
              pathReferenceVerbaleCessioneIRU,
            // pathReferenceVerbaleCessioneProprieta
            ];
            


           if(pratica.tipoSede === 'D' && pratica.ha2Tratte){
              filesToDownload.push(pathReferenceVerbaleCessioneProprieta);
            } 

            this.logger.info(filesToDownload);

          const downloadPromises = [];
          for (const pathRef of filesToDownload) {
            try {
              const blob = await getBlob(pathRef);
              if (blob) {
                this.logger.info(pathRef.name); 
                if(pathRef.name==='nt9.zip'){ 
                  zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_SHP_04_0").file("AB_"+pratica.codiceInfratel.substring(10,pratica.codiceInfratel.length)+".zip", blob);
                }else if( pathRef.name ==='ALLEGATO CONTRATTO IRU_'+pratica.codiceInfratel+'.pdf' 
                  || pathRef.name ==='Contratto_Cessione_IRU_'+pratica.codiceInfratel+".pdf.p7m"
                  || pathRef.name ==='Contratto_Cessione_Proprieta_Nuove_Infrastrutture_'+pratica.codiceInfratel+".pdf.p7m"){
                  zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/contratto di cessione").file(pathRef.name, blob);
                }else {
                  zip.file(pathRef.name, blob);
                }
                
                downloadPromises.push(Promise.resolve());
              } else {
                this.logger.info(`Errore durante il download di ${pathRef.name}`);
              }
            }catch(error){
              this.isLoadingResults = false;
              if (error.code === 'storage/object-not-found') {
                this.logger.info('Il file non esiste:', error.message);
                this.messageService.add({
                  severity: "info",
                summary: "Errore" , life:10000,
                  detail: "Il file "+ error.message+" non esiste",
                });
              } else {
                // Gestisci altri tipi di errori
                this.logger.info('Errore sconosciuto:', error);
              }
            }
          }
  
          Promise.all(downloadPromises)
          .then(() => {
            zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/documentazione fotografica");
            zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/istanze_autorizzazioni");
            zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/misure ottiche (eventuale)");
            // Crea il File zip e avvia il download:
            zip.generateAsync({ type: 'blob' })
              .then((blob) => {
                saveAs(blob, pratica.codiceInvio+'.zip'); // Scarica il File zip
              })
              .catch(error => this.logger.info('Errore durante la creazione dello zip:', error));
          })
          .catch(error => this.logger.info('Errore durante il download dei File:', error));
  
          this.isLoadingResults = false;
          
        },
        reject: () => {
        },
      });
    }else{
      this.isLoadingResults = true;
          const storage = getStorage();
          const zip = new JSZip();
          const pathReferenceNT9                      = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/IN/nt9.zip");
          const pathReferenceRET                      = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +   "/OUT/"+pratica.codiceRegione+"_F_RET_01_0.pdf");
          const pathReferencePSI                      = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +   "/OUT/"+pratica.codiceRegione+"_F_PSI_02_0.pdf");
          const pathReferenceCMT                      = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +   "/OUT/"+pratica.codiceRegione+"_F_CMT_03_0.xlsx");
          const pathReferenceAllegatoIRU              = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +   "/OUT/ALLEGATO CONTRATTO IRU_" + pratica.codiceInfratel + ".pdf" );
          const pathReferenceVerbaleCessioneIRU       = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +   "/OUT/SIGNED/Contratto_Cessione_IRU_" + pratica.codiceInfratel + ".pdf.p7m" );
          const pathReferenceVerbaleCessioneProprieta = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +   "/OUT/SIGNED/Contratto_Cessione_Proprieta_Nuove_Infrastrutture_" + pratica.codiceInfratel + ".pdf.p7m" );
          
          let filesToDownload = [
              pathReferenceNT9, 
              pathReferenceRET,
              pathReferencePSI,
              pathReferenceCMT,
              pathReferenceAllegatoIRU, 
              pathReferenceVerbaleCessioneIRU,
            // pathReferenceVerbaleCessioneProprieta
            ];
              if(pratica.tipoSede === 'D'){
              filesToDownload.push(pathReferenceVerbaleCessioneProprieta);
            }  
          const downloadPromises = [];
          for (const pathRef of filesToDownload) {
            try {
              const blob = await getBlob(pathRef);
              if (blob) {
                this.logger.info(pathRef.name); 
                if(pathRef.name==='nt9.zip'){ 
                  zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_SHP_04_0").file("AB_"+pratica.codiceInfratel.substring(10,pratica.codiceInfratel.length)+".zip", blob);
                }else if( pathRef.name ==='ALLEGATO CONTRATTO IRU_'+pratica.codiceInfratel+'.pdf' 
                  || pathRef.name ==='Contratto_Cessione_IRU_'+pratica.codiceInfratel+".pdf.p7m"
                  || pathRef.name ==='Contratto_Cessione_Proprieta_Nuove_Infrastrutture_'+pratica.codiceInfratel+".pdf.p7m"){
                  zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/contratto di cessione").file(pathRef.name, blob);
                }else {
                  zip.file(pathRef.name, blob);
                }
                
                downloadPromises.push(Promise.resolve());
              } else {
                this.logger.info(`Errore durante il download di ${pathRef.name}`);
              }
            }catch(error){
              this.isLoadingResults = false;
              if (error.code === 'storage/object-not-found') {
                this.logger.info('Il file non esiste:', error.message);
                this.messageService.add({
                  severity: "info",
                summary: "Errore" , life:10000,
                  detail: "Il file "+ error.message+" non esiste",
                });
              } else {
                // Gestisci altri tipi di errori
                this.logger.info('Errore sconosciuto:', error);
              }
            }
          }
  
          Promise.all(downloadPromises)
          .then(() => {
            zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/documentazione fotografica");
            zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/istanze_autorizzazioni");
            zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/misure ottiche (eventuale)");
            // Crea il File zip e avvia il download:
            zip.generateAsync({ type: 'blob' })
              .then((blob) => {
                saveAs(blob, pratica.codiceInvio+'.zip'); // Scarica il File zip
              })
              .catch(error => this.logger.info('Errore durante la creazione dello zip:', error));
          })
          .catch(error => this.logger.info('Errore durante il download dei File:', error));
  
          this.isLoadingResults = false;
    } */
    


    
    
  }

  openCaricaDocumentazionePratica(pratica: PraticaSanita_Firestore) {
    this.logger.info("---> CARICO DOCUMENTAZIONE E SOVRASCRIVO");
  }
  async openScaricaDocumentazionePratica(
    event: any,
    pratica: PraticaSanita_Firestore
  ): Promise<void> {
    this.logger.info("---> SCARICO DOCUMENTAZIONE PRODOTTA");
    /* this.selectedPraticaAtFirestore = pratica;
    this.loadAzioniScaricaFile();
    this.azioniScaricaDocMenu.toggle(event); */
  }

  async openCaricaFilePratica(  event: any, pratica: PraticaSanita_Firestore ): Promise<void> {
    this.logger.info("---> CARICO File PRATICA");
    /* this.selectedPraticaAtFirestore = pratica;
    this.loadAzioniCaricaFile(pratica);
    this.azioniCaricaFileMenu.toggle(event); */
  }
  async openCaricaAzioniPianoTecnico(  event: any, pianoTecnico: PianoTecnicoSanita_Firestore ): Promise<void> {
     this.selectedPianoTecnico = pianoTecnico;
    this.loadAzioni(event, pianoTecnico);
    this.azioniMenu.toggle(event); 
  }

  

  

  async loadRisultatiInvioPratica(  event: any, pratica: PraticaSanita_Firestore ): Promise<void> {
    /* this.selectedPraticaAtFirestore = pratica;
    this.loadAzioniRisultatoInvioPratica(pratica);
    this.azioniRisultatoInvioInfratel.toggle(event);  */
  }


  openModificaInformazioniPratica(pratica: PraticaSanita_Firestore): void {
  }

  openCompletaPraticaPresidioTIM(pratica: PraticaSanita_Firestore): void {
    this.logger.info("---> presidio completa la pratica");
    this.logger.info(pratica);

    /* let praticaDaAggiornare: PraticaScuola;
    let scuolaDaAggiornare: ScuolaDTO;
    this.praticheSanitaService
      .getById(pratica.id.toString())
      .subscribe((praticaDaDB) => {
        praticaDaAggiornare = praticaDaDB;

        this.ref = this.dialogService.open(DialogCompletaPratica, {
          data: {
            pratica: praticaDaAggiornare,
            praticaFirestore: pratica,
          },
          header: "Completamento Pratica "+pratica.codiceInfratel,
          width: this.isMobile ? "95%" : "85%",
          height: "85%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
        this.ref.onClose.subscribe((infoUpdated) => {
          if (infoUpdated && infoUpdated.success) {
            this.messageService.add({
              severity: "success",
              summary: "" , life:10000,
              detail: "Praticha completata con successo",
            });
          }
        });

      }); */

  }

  apriPraticheDelPianoTecnico(pianoTecnico: PianoTecnicoSanita_Firestore) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-sanita/pt/'+pianoTecnico.descrizione]));
  }

  caricaComputoMetrico(pianoTecnico: PianoTecnicoSanita_Firestore): void {
    this.ref = this.dialogService.open(DialogCaricaCMTPianoTecnicoSanita, {
      data: {
        pianoTecnico: pianoTecnico
      },
      header: "Carica Computo Metrico del Piano Tecnico "+pianoTecnico.descrizione,
      width: this.isMobile ? "95%" : "85%",
      height: "85%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((infoUpdated) => {
      if (infoUpdated && infoUpdated.success) {
        this.messageService.add({
          severity: "success",
          summary: "" , life:10000,
          detail: "Computo Metrico caricato con successo",
        });
      }else{
        this.messageService.add({
          severity: "info",
          summary: "Errore",
          detail: "Errore in fase di caricamento del computo metrico del piano tecnico", life:10000
        });
      }
    });
  }


  modificaPianoTecnico(pianoTecnico: PianoTecnicoSanita_Firestore): void {
    this.pianoTecnicoSanitaService.getById(pianoTecnico.id.toString()).subscribe((pianoTecnicoDaDB) => {
      this.ref = this.dialogService.open(DialogModificaPianoTecnicoSanita, {
        data: {
          pianoTecnico: pianoTecnicoDaDB
        },
        header: "Modifica Piano Tecnico "+pianoTecnico.descrizione,
        width: this.isMobile ? "95%" : "85%",
        height: "85%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((infoUpdated) => {
        if (infoUpdated && infoUpdated.success) {
          this.messageService.add({
            severity: "success",
            summary: "" , life:10000,
            detail: "Piano Tecnico modificato con successo",
          });
        }else{
          this.messageService.add({
            severity: "info",
            summary: "Errore",
            detail: "Errore in fase di modifica piano tecnico", life:10000
          });
        }
      });
    });
    
     
  }


  
  
  eliminaPianoTecnico(pianoTecnico: PianoTecnicoSanita_Firestore){
     this.confirmationService.confirm({
      message: `Confermi di voler ELIMINARE il PIANO TECNICO ${pianoTecnico.descrizione}?`,
      header: "ELIMINAZIONE",
      icon: "pi pi-eraser",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
       
        this.pianoTecnicoSanitaService.elimina(pianoTecnico.id).subscribe({
          next: (v) => {},
          error: (e) => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "info",
             summary: "Errore" , life:10000,
              detail: "Errore in fase di eliminazione del piano tecnico",
            });
          },
          complete: () => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "success",
              summary: "" , life:10000,
              detail: "Piano tecnico eliminato",
            });
          },
        });
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    }); 
  }

  

  scaricaPacchettiInBulk(){
    this.logger.info(  "-> scaricaPacchettiInBulk " );
   /*  let tipoFirma = "VERBALE FIRMATO";
    if(this.isDirigenteFirmaVerbali){
      tipoFirma = "IN FIRMA VERBALE";
    }
   
        const collectionRef = this.firestore.collection(this.collection_pratiche_sanita).ref;
        const query = collectionRef
          //.where("bando", "==", "BANDO 2")
          .where("stato", "==", tipoFirma);
          query.get().then(qs => {
            if (qs.docs && qs.docs.length > 0) {
              this.confirmationService.confirm({
                message: `Non rinominare i file che si stanno scaricando durante il processo di firma!`,
                header: "ATTENZIONE!",
                icon: "pi pi-exclamation-circle",
                acceptLabel: "PROCEDI",
                acceptButtonStyleClass: "p-button-success",
                rejectLabel: "ANNULLA",
                rejectButtonStyleClass: "p-button-warning",
                accept: async () => {
                  this.isLoadingResults = true;
                  const promises: Promise<void>[] = [];
    
                  qs.docs.forEach(doc =>{
                    let pratica = doc.data() as PraticaSanita_Firestore;
                    this.logger.info(  "-> SCARICO FILE PER PRATICA " +pratica.codiceInfratel);
    
                    if(this.isDirigenteFirmaPacchetti){
                      if(!pratica.colocata || (pratica.colocata && pratica.colocataRuolo==='PRINCIPALE')){
                        promises.push(this.scaricaPacchettoPratica(pratica, true));
                      } 
                    }else{
                      promises.push(this.scaricaVerbale(pratica, true));
                    }
             
                    });
                    Promise.all(promises)
                    .then(() => {
                      this.logger.info(  "-> HA FINITO! " );
                      this.isLoadingResults = false;
                    })
                    .catch(error => {
                      // Gestisci eventuali errori
                      this.logger.info("Errore durante le chiamate asincrone:", error);
                      this.isLoadingResults = false; // Assicurati di impostare isLoadingResults a false anche in caso di errore
                    });
                    
                },
                reject: () => {
                },
              });
             
              
            }else{
              this.messageService.add({severity:'info', summary:'', detail: 'Nessuna pratica da firmare'});
            }
        }); */
        
     

    
    
  }

  caricaPacchettiFirmatiInBulk(){
    this.logger.info(  "-> caricaPacchettiInBulk " );
   /*  const collectionRef = this.firestore.collection(this.collection_pratiche_sanita).ref;
    let tipoFirma = "VERBALE FIRMATO";
    if(this.isDirigenteFirmaVerbali){
      tipoFirma = "IN FIRMA VERBALE";
    }
    const query = collectionRef
      //.where("bando", "==", "BANDO 2")
      .where("stato", "==", tipoFirma);
      query.get().then(qs => {
        if (qs.docs && qs.docs.length > 0) {
          this.isLoadingResults = true;
          if(this.isDirigenteFirmaVerbali){
            //
            this.ref = this.dialogService.open(DialogCaricaVerbaliFirmati, {
              data: {
               
              },
              header: "Carica Verbali Firmati",
              width: "90%",
              height: "50%",
              baseZIndex: 10000,
              closable: true,
              draggable: false,
            });
            this.ref.onClose.subscribe((caricaPacchettiResult) => {
              this.isLoadingResults = false;

              if (caricaPacchettiResult && caricaPacchettiResult.success) {
                const messaggioSuccesso = caricaPacchettiResult.numeroPacchettiCaricati + " verbal* caricat* con successo";
                let messaggio = caricaPacchettiResult.numeroPacchettiNonCaricati== 0? messaggioSuccesso: messaggioSuccesso+ ' e '+ caricaPacchettiResult.numeroPacchettiNonCaricati+ " non caricat*!";
                this.messageService.add({
                  severity: "success",
                  summary: "" , life:10000,
                  detail: messaggio,
                  styleClass: 'custom-toast-pacchetti',
                });
              }
            });
          }else if(this.isDirigenteFirmaPacchetti) {
            this.ref = this.dialogService.open(DialogCaricaPacchettiFirmati, {
              data: {
               
              },
              header: "Carica "+this.isDirigenteFirmaVerbali?"Verbali":"Pacchetti"+" Firmati",
              width: "90%",
              height: "50%",
              baseZIndex: 10000,
              closable: true,
              draggable: false,
            });
            this.ref.onClose.subscribe((caricaPacchettiResult) => {
              this.isLoadingResults = false;
              if (caricaPacchettiResult && caricaPacchettiResult.success) {
                const messaggioSuccesso = caricaPacchettiResult.numeroPacchettiCaricati + " pacchett* caricat* con successo";
                let messaggio = caricaPacchettiResult.numeroPacchettiNonCaricati== 0? messaggioSuccesso: messaggioSuccesso+ ' e '+ caricaPacchettiResult.numeroPacchettiNonCaricati+ " non caricat*!";
                this.messageService.add({
                  severity: "success",
                  summary: "" , life:10000,
                  detail: messaggio,
            
                  styleClass: 'custom-toast-pacchetti',
                });
              }else{
                
              }
            });
          }
         
          
        }else{
          this.messageService.add({severity:'info', summary:'', detail: 'Nessuna pratica da firmare'});
        }
    }); */
    
    /**
     * USO ALTRO COMPONENTE
     */
  }
  assegnaPraticheInBulk() {
    //this.logger.info(  "-> assegnaPraticheInBulk " + this.selectedPratiche.length );
    /* let praticheDaAssegnare:PraticaScuola[]=[];
    this.selectedPratiche.forEach(pratica =>{
      let praticaDaAssegnare: PraticaScuola = new PraticaScuola();
      praticaDaAssegnare.codiceInfratel = pratica.codiceInfratel;
      praticaDaAssegnare.id = pratica.id;
      praticheDaAssegnare.push(praticaDaAssegnare);
    });
    this.ref = this.dialogService.open(DialogAssegnaPratica, {
      data: {
        pratiche: praticheDaAssegnare,
      },
      header: "Assegna pratiche in bulk",
      width: this.isMobile ? "95%" : "40%",
      height: "40%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((assegnaResult) => {
      if (assegnaResult && assegnaResult.success) {
        this.messageService.add({
          severity: "success",
          summary: "" , life:10000,
          detail: "Pratiche assegnata con successo",
        });
      }
    });
    this.selectedPratiche = []; */
  }

  


  openAssegnaAdImpresa(pratica: PraticaSanita_Firestore) {
   /*   let praticaDaAggiornare: PraticaSanita = new PraticaSanita();
    praticaDaAggiornare.codiceInfratel = pratica.codiceInfratel;
    praticaDaAggiornare.id = pratica.id;
    this.ref = this.dialogService.open(DialogAssegnaPraticaSanita, {
      data: {
        pratica: praticaDaAggiornare,
      },
      header: "Assegna pratica "+ pratica.codiceInfratel,
      width: this.isMobile ? "95%" : "40%",
      height: "40%",
      baseZIndex: 1,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((assegnaResult) => {
      if (assegnaResult && assegnaResult.success) {
        this.messageService.add({
          severity: "success",
          summary: "" , life:10000,
          detail: "Pratica assegnata con successo",
        });
      }
    });  */
  }

  openCaricaFotoRouter(pratica: PraticaSanita_Firestore): void {
    /* let praticaDaAggiornare: PraticaSanita = new PraticaSanita();
    praticaDaAggiornare.codiceInfratel = pratica.codiceInfratel;
    praticaDaAggiornare.id = pratica.id;

    this.ref = this.dialogService.open(DialogCaricaFotoRouterSanita, {
      data: {
        pratica: praticaDaAggiornare,
      },
      header: "Carica Fotografia del ROUTER della pratica "+ pratica.codiceInfratel,
      width: this.isMobile ? "95%" : "70%",
      height: "55%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((uploadResult) => {
      if (uploadResult.success) {
        const collectionRef = this.firestore.collection(this.collection_piani_tecnici_sanita);
        const documentRef = collectionRef.doc(pratica.codiceInfratel.valueOf());
        const updatedData = { fotoRouterUploaded: true };
        documentRef
          .update(updatedData)
          .then(() => {
            this.logger.log("Campo fotoRouterUploaded aggiornato con successo");
          })
          .catch((error) => {
            this.logger.error(
              "ERRORE AGGIORNATO CAMPO foto_router_uploaded SU FIRESTORE"
            );
          });
        this.praticheSanitaService
          .confermaCaricamentoFotoRouter(
            praticaDaAggiornare,
            uploadResult.fileExtension
          )
          .subscribe((res) => {
            this.logger.info("AGGIORNATA PRATICA DOPO CARICAMENTO FOTO ROUTER");
          });
        this.messageService.add({
          severity: "success",
          summary: "" , life:10000,
          detail: "Fotografia del router caricata con successo",
        });
      }
    });  */
  }

  openCaricaPlanimetria(pratica: PraticaSanita_Firestore): void {
    /* let praticaDaAggiornare: PraticaScuola = new PraticaScuola();
    praticaDaAggiornare.codiceInfratel = pratica.codiceInfratel;
    praticaDaAggiornare.id = pratica.id;

    this.ref = this.dialogService.open(DialogCaricaPlanimetria, {
      data: {
        pratica: praticaDaAggiornare,
      },
      header: "Carica Planimetria per pratica "+ pratica.codiceInfratel,
      width: this.isMobile ? "95%" : "70%",
      height: "55%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((uploadResult) => {
      if (uploadResult.success) {
        const collectionRef = this.firestore.collection(this.collection_pratiche_sanita);
        const documentRef = collectionRef.doc(pratica.codiceInfratel.valueOf());
        const updatedData = { planimetriaUploaded: true };
        documentRef
          .update(updatedData)
          .then(() => {
            this.logger.log(
              "Campo foto_router_uploaded aggiornato con successo"
            );
          })
          .catch((error) => {
            this.logger.error(
              "ERRORE AGGIORNATO CAMPO foto_router_uploaded SU FIRESTORE"
            );
          });
        this.praticheSanitaService
          .confermaCaricamentoPlanimetria(praticaDaAggiornare, uploadResult.fileExtension)
          .subscribe((res) => {
            this.logger.info("AGGIORNATA PRATICA DOPO CARICAMENTO PLANIMETRIA");
          });
        this.messageService.add({
          severity: "success",
          summary: "" , life:10000,
          detail: "Planimetria caricata con successo",
        });
      }
    }); */
  }

  openCaricaPacchettoNT9(pratica: PraticaSanita_Firestore): void {
    /* let praticaDaAggiornare: PraticaScuola = new PraticaScuola();
    praticaDaAggiornare.codiceInfratel = pratica.codiceInfratel;
    praticaDaAggiornare.id = pratica.id;

    this.ref = this.dialogService.open(DialogCaricaNT9, {
      data: {
        pratica: praticaDaAggiornare,
      },
      header: "Carica Pacchetto NT9 per pratica "+ pratica.codiceInfratel,
      width: this.isMobile ? "95%" : "70%",
      height: "55%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((uploadResult) => {
      if (uploadResult.success) {
        const collectionRef = this.firestore.collection(this.collection_pratiche_sanita);
        const documentRef = collectionRef.doc(pratica.codiceInfratel.valueOf());
        const updatedData = { nt9Uploaded: true };
        documentRef
          .update(updatedData)
          .then(() => {
            this.logger.log("Campo nt9_uploaded aggiornato con successo");
          })
          .catch((error) => {
            this.logger.error(
              "ERRORE AGGIORNATO CAMPO nt9_uploaded SU FIRESTORE"
            );
          });
        this.praticheSanitaService
          .confermaCaricamentoNT9(praticaDaAggiornare)
          .subscribe((res) => {
            this.logger.info("AGGIORNATA PRATICA DOPO CARICAMENTO REPORT NT9");
          });
        this.messageService.add({
          severity: "success",
          summary: "" , life:10000,
          detail: "Report NT9 caricato con successo",
        });
      }
    }); */
  }

  caricaShapeFirmato(pratica: PraticaSanita_Firestore): void {
    /* let praticaDaAggiornare: PraticaScuola = new PraticaScuola();
    praticaDaAggiornare.codiceInfratel = pratica.codiceInfratel;
    praticaDaAggiornare.id = pratica.id;
    praticaDaAggiornare.codiceInvio = pratica.codiceInvio;
    this.ref = this.dialogService.open(DialogCaricaNT9Firmato, {
      data: {
        pratica: praticaDaAggiornare,
      },
      header: "Carica Shape Firmato",
      width: this.isMobile ? "95%" : "70%",
      height: "55%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((uploadResult) => {
      if (uploadResult.success) {
        
        
      
    }
    }); */
  }
  caricaPacchettoFirmato(pratica: PraticaSanita_Firestore, isRicarica:boolean): void {
    /* let praticaDaAggiornare: PraticaScuola = new PraticaScuola();
    praticaDaAggiornare.codiceInfratel = pratica.codiceInfratel;
    praticaDaAggiornare.id = pratica.id;
    praticaDaAggiornare.codiceInvio = pratica.codiceInvio;
    this.ref = this.dialogService.open(DialogCaricaPacchettoFirmato, {
      data: {
        pratica: praticaDaAggiornare,
      },
      header: "Carica Pacchetto Firmato per pratica "+ pratica.codiceInfratel,
      width: this.isMobile ? "95%" : "70%",
      height: "55%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((uploadResult) => {
      if (uploadResult.success) {
        if(!isRicarica){
          this.praticheSanitaService
          .confermaCaricamentoPacchetto(praticaDaAggiornare)
          .subscribe((res) => {
            this.logger.info("AGGIORNATA PRATICA DOPO CARICAMENTO PACCHETTO");
            this.messageService.add({
              severity: "success",
              summary: "" , life:10000,
              detail: "Pacchetto firmato caricato con successo",
            }); 
          });
        } 

      }
    
    }); */
  }

  caricaVerbaleFirmato(pratica: PraticaSanita_Firestore, isRicarica:boolean): void {
    /* let praticaDaAggiornare: PraticaScuola = new PraticaScuola();
    praticaDaAggiornare.codiceInfratel = pratica.codiceInfratel;
    praticaDaAggiornare.id = pratica.id;
    praticaDaAggiornare.codiceInvio = pratica.codiceInvio;
    this.ref = this.dialogService.open(DialogCaricaVerbaleFirmato, {
      data: {
        pratica: praticaDaAggiornare,
      },
      header: "Carica Verbale Firmato della Pratica "+pratica.codiceInfratel,
      width: this.isMobile ? "95%" : "70%",
      height: "55%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((uploadResult) => {
      if (uploadResult.success) {
        if(!isRicarica){
          this.praticheSanitaService
          .confermaCaricamentoVerbale(praticaDaAggiornare)
          .subscribe((res) => {
            this.logger.info("AGGIORNATA PRATICA DOPO CARICAMENTO VERBALE");
          });
        }
       
        this.messageService.add({
          severity: "success",
          summary: "" , life:10000,
          detail: "Verbale caricato con successo",
        }); 
      }
    }); */
  }

  openVisualizzaDettagli(pratica: PraticaSanita_Firestore) {}
  openModificaDettagli(pratica: PraticaSanita_Firestore) {} 
  openAnnullaPratica(pratica: PraticaSanita_Firestore) {
    /* this.confirmationService.confirm({
      message: `Confermi di voler ANNULLARE la pratica ${pratica.codiceInfratel}?`,
      header: "ANNULLAMENTO",
      icon: "pi pi-times",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
        let praticaDaAnnullare: PraticaScuola = new PraticaScuola();
        praticaDaAnnullare.id = pratica.id;
        this.logger.info(praticaDaAnnullare);
        this.praticheSanitaService.annulla(praticaDaAnnullare).subscribe({
          next: (v) => {},
          error: (e) => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "info",
             summary: "Errore" , life:10000,
              detail: "Errore in fase di annullamento della pratica",
            });
          },
          complete: () => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "success",
              summary: "" , life:10000,
              detail: "Pratica annullata",
            });
          },
        });
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    }); */
  }

  openPreviewDocs(pratica: PraticaSanita_Firestore){
    /* this.confirmationService.confirm({
      message: `Confermi di voler procedere con la GENERAZIONE ed il DOWNLOAD dei documenti della pratica ${pratica.codiceInfratel}?`,
      header: "Generazione documenti",
      icon: "pi pi-File-import",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
        let praticaDaConsegnare: PraticaScuola = new PraticaScuola();
        praticaDaConsegnare.id = pratica.id;
        this.logger.info(praticaDaConsegnare);
        this.praticheSanitaService.generaDocs(praticaDaConsegnare).subscribe({
          next: (v) => {},
          error: (e) => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "info",
             summary: "Errore" , life:10000,
              detail: "Errore in fase di generazione dei docs della pratica",
            });
          },
          complete: () => {
            this.messageService.add({
              severity: "success",
              summary: "" , life:10000,
              detail: "Generazione documentazione avvenuta, attendere il download!",
            });
            //scarica tutto!
            this.isLoadingResults = false;
            if(pratica.colocata){
              this.scaricaPreviewDocsPraticaColocata(pratica);
            }else {
              this.scaricaPreviewDocsPratica(pratica);
            }
            
          },
        });
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    }); */
  }

  async scaricaPreviewDocsPratica(pratica: PraticaSanita_Firestore) {
    this.logger.info("---> SCARICO LA PREVIEW DEI DOCS DELLA PRATICA "+pratica.codiceInfratel);
    /* const storage = getStorage();
    const zip = new JSZip();
    const pathReferenceRET                    = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/"+pratica.codiceRegione +"_F_RET_01_0.docx");
    const pathReferencePSI                    = ref( storage, "pratiche/scuola/" + pratica.codiceInfratel +  "/OUT/"+pratica.codiceRegione +"_F_PSI_02_0.docx");
    const pathReferenceAllegatoIRU            = ref( storage, "pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/ALLEGATO CONTRATTO IRU_" + pratica.codiceInfratel + ".docx" );
    let filesToDownload = [
        pathReferenceRET,
        pathReferencePSI,
        pathReferenceAllegatoIRU, 
      ];

    const downloadPromises = [];
    for (const pathRef of filesToDownload) {
      const blob = await getBlob(pathRef);
      if (blob) {
        this.logger.info(pathRef.name);
        zip.file(pathRef.name, blob);
        
        downloadPromises.push(Promise.resolve());
      } else {
        this.logger.info(`Errore durante il download di ${pathRef.name}`);
      }
    }
    Promise.all(downloadPromises)
    .then(() => {
      // Crea il File zip e avvia il download:
      zip.generateAsync({ type: 'blob' })
        .then((blob) => {
          saveAs(blob, pratica.codiceInfratel+'.zip'); // Scarica il File zip
          this.isLoadingResults = false;
        })
        .catch(error => this.logger.info('Errore durante la creazione dello zip:', error));
    })
    .catch(error => this.logger.info('Errore durante il download dei File:', error)); */
    
  }

  

  openAnnullaConsegnaPratica(pratica: PraticaSanita_Firestore): void {
    /* this.logger.info("---> ANNULLA CONSEGNA PRATICA");
     this.confirmationService.confirm({
      message: `Confermi di voler ANNULLARE la CONSEGNA  della pratica ${pratica.codiceInfratel}?`,
      header: "Consegna",
      icon: "pi pi-File-import",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
        this.logger.info(localStorage.getItem("idUtente"));
        let praticaDaConsegnare: PraticaScuola = new PraticaScuola();
        praticaDaConsegnare.id = pratica.id;
        this.logger.info(praticaDaConsegnare);
        this.praticheSanitaService.annullaConsegna(praticaDaConsegnare).subscribe({
          next: (v) => {},
          error: (e) => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "info",
             summary: "Errore" , life:10000,
              detail: "Errore in fase di annullamento della consegna della pratica",
            });
          },
          complete: () => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "success",
              summary: "" , life:10000,
              detail: "Consegna della pratica annullata",
            });
          },
        });
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    });  */
  }
  async unzipBlob(blob) {
    const zip = await JSZip.loadAsync(blob);
    const files = [];
    await Promise.all(
        Object.keys(zip.files).map(async (filename) => {
            const fileData = await zip.files[filename].async("uint8array");
            files.push({ filename, data: fileData });
        })
    );
    return files;
}
  async scaricaPacchettoPianoTecnico(pianoTecnico: PianoTecnicoSanita_Firestore): Promise<void> {
    this.logger.info("---> SCARICA PACCHETTO DEL PIANO TECNICO " + pianoTecnico.descrizione);
    const regione_match = pianoTecnico.descrizione.match(/PT_(.*?)_STD_/);
    const regione = regione_match ? regione_match[1] : null;
    const id_match = pianoTecnico.descrizione.match(/STD_(.*?)$/);
    const id = id_match ? id_match[1] : null;
    this.logger.info("---> IPOTESI CARTELLA SHAPE SHP_AB_" + regione+"_T_"+id + "_201");

    //SCARICA RET
    //SCARICA TUTTI I PACCHETTI DELLE PRATICHE CONSEGNATE
    this.isLoadingResults = true;
          const storage = getStorage();
          const zip = new JSZip();
          const zipShape = new JSZip();
          const nomeRET=pianoTecnico.pdc.toUpperCase() +  "_RET_01.docx";
          const nomeCMT=pianoTecnico.pdc.toUpperCase() +  "_CMT_04_0.xlsx";
          const pathReferenceRET                       = ref( storage, "pratiche/sanita/RET/" + nomeRET);
          const pathReferenceCMT                       = ref( storage, "pratiche/sanita/CMT/" + nomeCMT);
       //   const pathReferenceAllegatoIRU               = ref( storage, "pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/ALLEGATO CONTRATTO IRU_" + pratica.codiceInfratel + ".pdf" );
       //   const pathReferenceVerbaleCessioneIRU        = ref( storage, "pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/SIGNED/Contratto_Cessione_IRU_" + pratica.codiceInfratel + ".pdf.p7m" );  
       //   const pathReferenceVerbaleCessioneProprieta  = ref( storage, "pratiche/scuola/" +  pratica.codiceInfratel +"/OUT/SIGNED/Contratto_Cessione_Proprieta_Nuove_Infrastrutture_" + pratica.codiceInfratel + ".pdf.p7m" );
          let filesToDownload = [
              pathReferenceRET,
              pathReferenceCMT,
             // pathReferenceAllegatoIRU, 
             // pathReferenceVerbaleCessioneIRU,
             ];
            this.pianoTecnicoSanitaService.getPraticheConsegnate(pianoTecnico.id).subscribe(async praticheConsegnate =>{
              this.logger.info("IL PIANO HA  "+ praticheConsegnate.length + " PRATICHE CONSEGNATE!"); 
              praticheConsegnate.forEach(async praticaConsegnata => {
                this.logger.info("1) PROCESSO PRATICA "+ praticaConsegnata.codiceInfratel); 

                const pathReferenceShapePraticaConsegnata           = ref( storage, "pratiche/sanita/"+praticaConsegnata.codiceInfratel+"/OUT/"+praticaConsegnata.strutturaSanitaria.codiceAccessoInfratel + ".zip");
                const pathReferenceAllegatoIRUPraticaConsegnata     = ref( storage, "pratiche/sanita/" + praticaConsegnata.codiceInfratel +"/OUT/ALLEGATO CONTRATTO IRU_" + praticaConsegnata.codiceInfratel + ".docx" );

                const blobShape =  getBlob(pathReferenceShapePraticaConsegnata);
                if (blobShape) {//PC_MAR_V_005_001_06_0
                  //zip.folder(pianoTecnico.descrizione+"/"+praticaConsegnata.codiceInfratel+"/"+pianoTecnico.pdc+"_06_0").file(praticaConsegnata.strutturaSanitaria.codiceAccessoInfratel+".zip", blobShape);
                 // zip.folder(pianoTecnico.descrizione+"/"+pianoTecnico.pdc+"_06_0").file(praticaConsegnata.strutturaSanitaria.codiceAccessoInfratel+".zip", blobShape);
                  //zipShape.folder(praticaConsegnata.strutturaSanitaria.codiceAccessoInfratel).file(praticaConsegnata.strutturaSanitaria.codiceAccessoInfratel+".zip", blobShape);
                  const zipFiles = await this.unzipBlob(blobShape);
                  zipFiles.forEach((file) => {
                      const fileName = file.filename;
                      const fileData = file.data;
                      this.logger.info(file.filename);
                      zipShape.file(file.filename, file.data);
                      // Ora puoi salvare fileName e fileData come desideri
                      // Ad esempio, puoi scrivere fileData in un nuovo blob
                      // e salvarlo con il nome fileName
                  });
                  
                  
                  //zipShape.folder("I-MAR-042021-001").file(praticaConsegnata.codiceInfratel+".zip", blobShape);
                  this.logger.info("2) SCARICATO PACCHETTO NTX "+ pathReferenceShapePraticaConsegnata.name); 
                }
                const blobAllegatoIRU = getBlob(pathReferenceAllegatoIRUPraticaConsegnata);
                if (blobAllegatoIRU) {
                 //zip.folder(pianoTecnico.descrizione+"/"+praticaConsegnata.codiceInfratel+"/"+pianoTecnico.pdc+"_07_0/contratto di cessione").file("ALLEGATO CONTRATTO IRU_" + praticaConsegnata.codiceInfratel + ".docx", blobAllegatoIRU );
                  zip.folder(pianoTecnico.descrizione+"/"+pianoTecnico.pdc+"_07_0/contratto di cessione").file("ALLEGATO CONTRATTO IRU_" + praticaConsegnata.codiceInfratel + ".docx", blobAllegatoIRU );
                  
                  this.logger.info("3) SCARICATO allegato iru "+ pathReferenceAllegatoIRUPraticaConsegnata.name); 
                 
               
                }
                 
              });
              const downloadPromises = [];
               for (const pathRef of filesToDownload) {

                try {
                  const blob = await getBlob(pathRef);
                  if (blob) {
                    this.logger.info("DEVO SCARICARE IL FILE "+ pathRef.name); 
                   /* if(pathRef.name==='nt9.zip'){ 
                      zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_SHP_04_0").file("AB_"+pratica.codiceInfratel.substring(10,pratica.codiceInfratel.length)+".zip", blob);
                    }else if( pathRef.name ==='ALLEGATO CONTRATTO IRU_'+pratica.codiceInfratel+'.pdf' 
                      || pathRef.name ==='Contratto_Cessione_IRU_'+pratica.codiceInfratel+".pdf.p7m"
                      || pathRef.name ==='Contratto_Cessione_Proprieta_Nuove_Infrastrutture_'+pratica.codiceInfratel+".pdf.p7m"){
                      zip.folder(pratica.codiceInfratel+"/"+pratica.codiceRegione+"_F_ANN_05_0/contratto di cessione").file(pathRef.name, blob);
                    }else  */
                    if(pathRef.name.endsWith('RET_01.docx') || pathRef.name.endsWith('CMT_04_0.xlsx')){
                      this.logger.info("SCARICATO FILE "+ pathRef.name); 

                      zip.folder(pianoTecnico.descrizione).file(pathRef.name, blob);

                    }{
                      zip.file(pianoTecnico.descrizione+"/"+pathRef.name, blob);
                    }
                    downloadPromises.push(Promise.resolve()); 
                    
                  } else {
                    this.logger.info(`Errore durante il download di ${pathRef.name}`);
              } 
            }catch(error){
              this.isLoadingResults = false;
              if (error.code === 'storage/object-not-found') {
                this.logger.info('Il file non esiste:', error.message);
                this.messageService.add({
                  severity: "info",
                summary: "Errore" , life:10000,
                  detail: "Il file "+ error.message+" non esiste",
                });
              } else {
                // Gestisci altri tipi di errori
                this.logger.info('Errore sconosciuto:', error);
              }
             
            }
            Promise.all(downloadPromises)
            .then(() => {
              
              if(downloadPromises.length==2){
                zipShape.generateAsync({ type: 'blob' })
                .then((blob) => {
                  zip.folder(pianoTecnico.descrizione).file("SHP_AB_" + regione+"_T_"+id + "_201.zip",blob);
                  this.logger.info("*** scarico zippone finale ");
                    zip.folder(pianoTecnico.descrizione+"/"+pianoTecnico.pdc+"_07_0/documentazione fotografica");
                    zip.folder(pianoTecnico.descrizione+"/"+pianoTecnico.pdc+"_07_0/istanze_autorizzazioni");
                    zip.generateAsync({ type: 'blob' })
                    .then((blobFinale) => {
                      this.logger.info("*** salvo file");
                      saveAs(blobFinale, pianoTecnico.descrizione+'.zip'); // Scarica il File zip
                    })
                    .catch(error => this.logger.info('Errore durante la creazione dello zip:', error));
                })
                .catch(error => this.logger.info('Errore durante la creazione dello zip:', error));
                
              }
          
              })
            .catch(error => this.logger.info('Errore durante il download dei File:', error));
     
            this.isLoadingResults = false;
          }

            });

           
  
         
    
  }
  generaRET(pianoTecnico: PianoTecnicoSanita_Firestore): void {
    this.confirmationService.confirm({
      message: `Confermi di voler generare la RET del piano tecnico ${pianoTecnico.descrizione}?`,
      header: "Generazione RET",
      icon: "pi pi-File-import",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
       
        this.pianoTecnicoSanitaService
          .generaRET(pianoTecnico.id)
          .subscribe({
            next: (v) => {},
            error: (e) => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "info",
               summary: "Errore" , life:10000,
                detail: "Errore in fase di generazione RET",
              });
            },
            complete: async () => {
              //this.isLoadingResults = false;
              const storage = getStorage();
              const nomeRET=pianoTecnico.pdc+"_RET_01.docx";
              const pathReferenceZipShape    = ref( storage, "pratiche/sanita/RET/"+nomeRET);
              const blob = await getBlob(pathReferenceZipShape);
              saveAs(blob, nomeRET); 
              this.isLoadingResults = false;
            },
          });
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    });  

  }
  openInCaricoPresidio(pratica: PraticaSanita_Firestore): void {

     /* this.confirmationService.confirm({
      message: `Confermi di voler prendere in carico la pratica ${pratica.codiceInfratel}?`,
      header: "Presa in carico",
      icon: "pi pi-File-import",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
        let praticaDaPrendereInCarico: PraticaSanita = new PraticaSanita();
        praticaDaPrendereInCarico.id = pratica.id;
        this.logger.info(praticaDaPrendereInCarico);
        this.praticheSanitaService
          .presidioPrendeInCarico(praticaDaPrendereInCarico)
          .subscribe({
            next: (v) => {},
            error: (e) => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "info",
               summary: "Errore" , life:10000,
                detail: "Errore in fase di presa in carico della pratica",
              });
            },
            complete: () => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "success",
                summary: "" , life:10000,
                detail: "Pratica presa in carico",
              });
            },
          });
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    });  */
  }
  openPrendiInCarico(pratica: PraticaSanita_Firestore): void {
     /* this.confirmationService.confirm({
      message: `Confermi di voler prendere in carico la pratica ${pratica.codiceInfratel}?`,
      header: "Presa in carico",
      icon: "pi pi-File-import",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
        this.logger.info(localStorage.getItem("idUtente"));
        let praticaDaModificare: PraticaSanita = new PraticaSanita();
        let utenteInCarico: Utente = new Utente();
        utenteInCarico.id = Number.parseInt(localStorage.getItem("idUtente"));
        praticaDaModificare.id = pratica.id;
        praticaDaModificare.utenteAssegnato = utenteInCarico;
        this.logger.info(praticaDaModificare);
        this.praticheSanitaService
          .prendiInCarico(praticaDaModificare)
          .subscribe({
            next: (v) => {},
            error: (e) => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "info",
               summary: "Errore" , life:10000,
                detail: "Errore in fase di presa in carico della pratica",
              });
            },
            complete: () => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "success",
                summary: "" , life:10000,
                detail: "Pratica presa in carico",
              });
            },
          });
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    });  */
  }

  openRichiediModificaCentrale(pratica: PraticaSanita_Firestore): void {
    this.logger.info("--->  RICHIEDI CAMBIO CENTRALE DELLA PRATICA " + pratica.codiceInfratel);
    
     /*      this.ref = this.dialogService.open(DialogRichiediCambioCentrale, {
            data: {
              pratica: pratica,
             
            },
            header: "Richiesta cambio centrale ",
            width: this.isMobile ? "95%" : "85%",
            height: "50%",
            baseZIndex: 10000,
            closable: true,
            draggable: false,
          });
          this.ref.onClose.subscribe((changeRequested) => {
            if (changeRequested && changeRequested.success) {
              this.messageService.add({
                severity: "success",
                summary: "" , life:10000,
                detail: "Richiesta inviata con successo",
              });
            }
          }); */
  
  }

  openIniziaProgettazione(pratica: PraticaSanita_Firestore): void {
    /* this.logger.info("--->  INIZIA PROGETTAZIONE PRATICA");
     this.confirmationService.confirm({
      message: `Confermi di voler iniziare la progettazione della pratica ${pratica.codiceInfratel}?`,
      header: "Inizio Progettazione",
      icon: "pi pi-file-edit",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.logger.info(localStorage.getItem("idUtente"));
        this.isLoadingResults = true;
        let praticaDaModificare: PraticaScuola = new PraticaScuola();
        this.logger.info(praticaDaModificare);

        praticaDaModificare.id = pratica.id;
        this.praticheSanitaService
          .iniziaProgettazione(pratica)
          .subscribe({
            next: (v) => {},
            error: (e) => {
              this.messageService.add({
                severity: "info",
               summary: "Errore" , life:10000,
                detail: "Errore in fase di inizio progettazione della pratica",
              });
              this.isLoadingResults = false;
            },
            complete: () => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "success",
                summary: "" , life:10000,
                detail: "Inizio progettazione avvenuto con successo",
              });
            },
          });
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    });  */
   
  }

}

@Component({
  selector: "app-crea-piano-tecnico",
  templateUrl: './dialog-crea-piano-tecnico-sanita.component.html',
  styleUrls: ['./piani-tecnici-sanita.component.scss']
})
export class DialogCreaPianoTecnicoSanita implements OnInit {

  protected _onDestroy = new Subject<void>();
  protected creaPianoTecnicoSanitaForm: FormGroup;
  protected ref: DynamicDialogRef;

  protected comuni:ComuneDTO[]=[];
  protected filteredComuni: any[] =[];
  protected selectedComune: ComuneDTO ;
  protected comuniLoaded:boolean=false;

  constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private _formBuilder: FormBuilder,
      private messageService:MessageService,
      private comuniService: ComuniService,
      public dialogService: DialogService,
      private pianoTecnicoService:PianoTecnicoSanitaService,
    ) {
  }

  ngOnInit(): void {
    this.loadComuni();
    this.creaPianoTecnicoSanitaForm = this._formBuilder.group({
      id:     [null, [Validators.required]],
      pdc:    [null, [Validators.required]],
      cig:    [null, [Validators.required]],
      comune:  [null, [Validators.required]]

    });

  }
 
  loadComuni() {
     this.comuniService.get().subscribe((res) => {
      this.comuni = res;
      this.comuniLoaded = true;
    }); 
  }
  filterComune(event: AutoCompleteCompleteEvent) {
     let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < this.comuni.length; i++) {
        let comune = this.comuni[i];
        if (comune.denominazione.toLowerCase().indexOf(query.toLowerCase()) == 0) {
          filtered.push(comune);
        }
    }
    this.filteredComuni = filtered; 
  }

  
  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {

      let nuovoPianoTecnico:PianoTecnicoSanita = new PianoTecnicoSanita();
      nuovoPianoTecnico.descrizione  = this.creaPianoTecnicoSanitaForm.value.id;
      nuovoPianoTecnico.pdc = this.creaPianoTecnicoSanitaForm.value.pdc;
      nuovoPianoTecnico.cig = this.creaPianoTecnicoSanitaForm.value.cig;
      nuovoPianoTecnico.comune = this.creaPianoTecnicoSanitaForm.value.comune;
     

      this.pianoTecnicoService.crea(nuovoPianoTecnico).subscribe(res => {
        const pianoTecnicoCreato = res;
        this.dialogRef.close({ success: true, pianoTecnicoCreato :pianoTecnicoCreato });
      });

    }
  }
  
}

@Component({
  selector: "app-modifica-piano-tecnico",
  templateUrl: './dialog-modifica-piano-tecnico-sanita.component.html',
  styleUrls: ['./piani-tecnici-sanita.component.scss']
})
export class DialogModificaPianoTecnicoSanita implements OnInit {

  protected _onDestroy = new Subject<void>();
  protected modificaPianoTecnicoSanitaForm: FormGroup;
  protected pianoTecnicoDaModificare: PianoTecnicoSanita;
  protected ref: DynamicDialogRef;

  protected comuni:ComuneDTO[]=[];
  protected filteredComuni: any[] =[];
  protected selectedComune: ComuneDTO ;
  protected comuniLoaded:boolean=false;

  constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private _formBuilder: FormBuilder,
      private messageService:MessageService,
      private comuniService: ComuniService,
      public dialogService: DialogService,
      private pianoTecnicoService:PianoTecnicoSanitaService,
    ) {
  }

  ngOnInit(): void {
    this.pianoTecnicoDaModificare = this.config.data.pianoTecnico;
    this.loadComuni();
    this.modificaPianoTecnicoSanitaForm = this._formBuilder.group({
        
      id:    new FormControl({value: this.pianoTecnicoDaModificare.descrizione, disabled: true}, Validators.required), 
      pdc:    [this.pianoTecnicoDaModificare.pdc, [Validators.required]],
      cig:    [this.pianoTecnicoDaModificare.cig, [Validators.required]],
      comune:  [this.pianoTecnicoDaModificare.comune, [Validators.required]]

    });

  }
 
  loadComuni() {
     this.comuniService.get().subscribe((res) => {
      this.comuni = res;
      this.comuniLoaded = true;
    }); 
  }
  filterComune(event: AutoCompleteCompleteEvent) {
     let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < this.comuni.length; i++) {
        let comune = this.comuni[i];
        if (comune.denominazione.toLowerCase().indexOf(query.toLowerCase()) == 0) {
          filtered.push(comune);
        }
    }
    this.filteredComuni = filtered; 
  }

  
  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      let pianoTecnicoDaAggiornare:PianoTecnicoSanita = new PianoTecnicoSanita();
      pianoTecnicoDaAggiornare.id           = this.pianoTecnicoDaModificare.id;
     // pianoTecnicoDaAggiornare.descrizione  = this.modificaPianoTecnicoSanitaForm.value.id;
      pianoTecnicoDaAggiornare.pdc          = this.modificaPianoTecnicoSanitaForm.value.pdc;
      pianoTecnicoDaAggiornare.cig          = this.modificaPianoTecnicoSanitaForm.value.cig;
      pianoTecnicoDaAggiornare.comune       = this.modificaPianoTecnicoSanitaForm.value.comune;
      
     // this.pianoTecnicoDaModificare.id           = this.pianoTecnicoDaModificare.id;
    // this.pianoTecnicoDaModificare.descrizione  = this.modificaPianoTecnicoSanitaForm.value.id;
     this.pianoTecnicoDaModificare.pdc          = this.modificaPianoTecnicoSanitaForm.value.pdc;
     this.pianoTecnicoDaModificare.cig          = this.modificaPianoTecnicoSanitaForm.value.cig;
     this.pianoTecnicoDaModificare.comune       = this.modificaPianoTecnicoSanitaForm.value.comune;
     

      this.logger.info('pianoTecnicoDaAggiornare: ' + JSON.stringify(this.pianoTecnicoDaModificare));
     

      this.pianoTecnicoService.modifica( this.pianoTecnicoDaModificare).subscribe(res => {
          const pianoTecnicoModificato = res;
          this.dialogRef.close({ success: true, pianoTecnicoModificato:pianoTecnicoModificato });
        }),
        error => {
          console.error('ERRORE MODIFICA PIANO TECNICO' + error);
          this.dialogRef.close({
            success: false
          });
      }

    }
  }
  
}


@Component({
  selector: "app-carica-cmt-piano-tecnico",
  templateUrl: "./dialog-carica-cmt-piano-tecnico-sanita.component.html",
  styleUrls: ['./piani-tecnici-sanita.component.scss']
})
export class DialogCaricaCMTPianoTecnicoSanita implements OnInit {
  protected _onDestroy = new Subject<void>();
  public pianoTecnico: PianoTecnicoSanita;
  selectedFile: File = null;
  isComputoMetricoUploaded: boolean = false;
  isLoadingResults: boolean = false;
  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private googleStorageService: GoogleStorageService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.pianoTecnico = this.config.data.pianoTecnico;
  }
  onComputoMetricoUpload($event) {
    this.isComputoMetricoUploaded = true;
    this.selectedFile = $event.files[0];
  }
  onComputoMetricoRemove() {
    this.isComputoMetricoUploaded = false;
  }
  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      const fileExtension = this.selectedFile.name.substring(
        this.selectedFile.name.lastIndexOf(".") + 1
      );
      const fileName =
        this.pianoTecnico.pdc + "_CMT_04_0." + fileExtension;
      this.googleStorageService
        .uploadFileCMTPianoTecnicoSanitaToGoogleStorage(this.selectedFile, fileName)
        .then((uploadRes) => {
          this.dialogRef.close({ success: true, fileExtension: fileExtension });
        })
        .catch((errore) => {
          this.messageService.add({
            severity: "info",
           summary: "Errore" , life:10000,
            detail: "Errore in fase di caricamento File!",
          });

          this.dialogRef.close({ success: false });
        });
    }
  }
}